//基础结构
<template>
  <div class="home-container">
    <!-- 左侧工具栏 -->
    <div class="tools-sidebar">
    <!-- 预设动作模块 -->
      <div class="module-card">
        <h3 class="module-title">预设动作</h3>
      <div class="preset-action-wrapper">
        <select 
          v-model.number="selectedPreset" 
          class="preset-select"
          :disabled="isExecutingPreset"
        >
          <option value="">选择预设动作</option>
          <option 
            v-for="preset in presetActions" 
            :key="preset.id" 
            :value="preset.id"
          >
            {{ preset.description }}
          </option>
        </select>
        <button 
          v-if="selectedPreset" 
          @click="executePreset" 
            class="tool-btn"
          :disabled="isExecutingPreset || layers.length < 2"
        >
          {{ isExecutingPreset ? '执行中...' : '执行动作' }}
        </button>
      </div>
    </div>
    
      <!-- 编辑操作模块 -->
      <div class="module-card edit-actions-module">
        <h3 class="module-title">编辑操作</h3>
        <div class="action-groups">
          <!-- 基础编辑操作 -->
          <div class="action-group primary-actions">
            <button @click="undoLastOperation" class="action-btn primary-action" :disabled="canvasHistory.length === 0" title="撤销上一步操作">
              <span class="action-icon">↩</span>
              <span class="action-label">撤销</span>
        </button>
            <button @click="resetCanvas" class="action-btn primary-action" :disabled="!imageLoaded" title="重置画布">
              <span class="action-icon">⟲</span>
              <span class="action-label">重置</span>
            </button>
            <button @click="goToClassicVersion" class="action-btn primary-action classic-version-btn" title="切换到经典模式">
              <span class="action-icon">🔙</span>
              <span class="action-label">经典版</span>
            </button>
          </div>

          <!-- 图层操作按钮 -->
          <div class="action-group layer-actions" v-if="activeLayerIndex >= 0">
            <div class="action-group-title">图层操作</div>
            <div class="action-buttons-grid">
              <button @click="duplicateLayer(activeLayerIndex)" class="action-btn secondary-action" title="复制当前图层">
                <span class="action-icon">⎘</span>
                <span class="action-label">复制</span>
              </button>
              <button @click="renameLayer" class="action-btn secondary-action" title="重命名当前图层">
                <span class="action-icon">✎</span>
                <span class="action-label">重命名</span>
              </button>
              <button @click="toggleLayerMoveControls" class="action-btn secondary-action" :class="{'active-tool': showLayerMoveControls}" title="移动图层位置">
                <span class="action-icon">↕</span>
                <span class="action-label">移动</span>
              </button>
              <button @click="mergeDown" class="action-btn secondary-action" :disabled="activeLayerIndex >= layers.length - 1" title="向下合并图层">
                <span class="action-icon">⇓</span>
                <span class="action-label">向下合并</span>
              </button>
              <button @click="showMergeOptions" class="action-btn secondary-action" :disabled="layers.length < 2" title="合并所有可见图层">
                <span class="action-icon">⋈</span>
                <span class="action-label">合并可见</span>
              </button>
        </div>
      </div>
    </div>
    
        <!-- 图层移动控制面板 -->
        <div v-if="showLayerMoveControls && activeLayerIndex >= 0" class="layer-move-controls">
          <div class="move-panel-header">
            <span class="move-panel-title">图层位置调整</span>
            <span class="position-display">当前位置: {{ layers[activeLayerIndex].offsetX || 0 }}×{{ layers[activeLayerIndex].offsetY || 0 }}</span>
        </div>
          
          <div class="move-controls-grid">
            <button class="direction-btn up-btn" @click="moveLayerPosition(0, -1)" title="向上移动">
              <span class="direction-icon">↑</span>
            </button>
            <button class="direction-btn left-btn" @click="moveLayerPosition(-1, 0)" title="向左移动">
              <span class="direction-icon">←</span>
            </button>
            <div class="direction-center"></div>
            <button class="direction-btn right-btn" @click="moveLayerPosition(1, 0)" title="向右移动">
              <span class="direction-icon">→</span>
            </button>
            <button class="direction-btn down-btn" @click="moveLayerPosition(0, 1)" title="向下移动">
              <span class="direction-icon">↓</span>
            </button>
    </div>
    
          <div class="move-panel-footer">
            <button class="reset-position-btn" @click="resetLayerPosition" title="重置图层位置">
              <span class="reset-icon">⟲</span> 重置位置
            </button>
            <button class="close-panel-btn" @click="toggleLayerMoveControls" title="关闭移动面板">
              <span class="close-icon">✕</span> 关闭
            </button>
        </div>
      </div>
    </div>

    <!-- 图层管理模块 -->
      <div class="module-card" v-if="layers.length > 0">
      <h3 class="module-title">图层管理</h3>
      <div class="layers-list">
        <div 
          v-for="(layer, index) in layers" 
          :key="layer.id"
          :class="['layer-item', activeLayerIndex === index ? 'active-layer' : '']"
          @click="setActiveLayer(index)"
        >
          <div class="layer-preview">
            <img :src="layer.thumbnail" alt="图层预览" class="layer-thumbnail" />
          </div>
          <div class="layer-info">
            <div class="layer-name">{{ layer.name }}</div>
            <div class="layer-controls">
              <input 
                type="range" 
                min="0" 
                max="100" 
                v-model="layer.opacity" 
                @input="updateLayerOpacity(index)"
              />
              <span class="layer-opacity">{{ layer.opacity }}%</span>
            </div>
          </div>
          <div class="layer-actions">
            <button @click.stop="toggleLayerVisibility(index)" class="visibility-btn">
              <img :src="layer.visible ? icons.look : icons.unlook" alt="visibility" class="action-icon"/>
            </button>
            <button @click.stop="moveLayerUp(index)" class="order-btn" :disabled="index === 0" title="上移图层">
              <span class="order-icon">↑</span>
            </button>
            <button @click.stop="moveLayerDown(index)" class="order-btn" :disabled="index === layers.length - 1" title="下移图层">
              <span class="order-icon">↓</span>
            </button>
            <button @click.stop="deleteLayer(index)" class="delete-btn">
              <img :src="icons.deleate" alt="delete" class="action-icon"/>
            </button>
          </div>
        </div>
      </div>
      <div class="layer-add-section">
          <button @click="triggerFileInput" class="tool-btn">
          <span class="plus-icon">+</span> 添加图层
        </button>
      </div>
    </div>
    
      <!-- 图层工具模块 -->
      <div class="module-card layer-tools-module" v-if="imageLoaded">
        <h3 class="module-title">图层工具</h3>
        <div class="layer-tools">
          <!-- 工具按钮区域 -->
          <div class="layer-tool-buttons">
            <button 
              class="tool-btn"
              @click="invertLayer"
              :disabled="activeLayerIndex < 0"
            >
              反相
        </button>
            <button 
              class="layer-tool-btn"
              @click="openStrokeOptions"
              :disabled="activeLayerIndex < 0"
            >
              描边
        </button>
            <button 
              class="tool-btn"
              @click="selectAll"
              :disabled="activeLayerIndex < 0"
            >
              全选
        </button>
            <button 
              class="tool-btn"
              @click="openFillOptions"
              :disabled="activeLayerIndex < 0 || !hasSelection"
            >
              填充
        </button>
            <button 
              class="tool-btn"
              @click="openFillLayerOptions"
              :disabled="activeLayerIndex < 0"
            >
              填充图层
        </button>
      </div>
      
          <!-- 描边工具选项面板 -->
          <div class="layer-tool-options" v-if="showStrokePanel && activeLayerIndex >= 0">
            <div class="option-panel">
              <div class="option-header">
                <h4 class="option-title">描边设置</h4>
                <button class="close-btn" @click="closeStrokePanel">&times;</button>
          </div>
              
              <div class="stroke-option">
                <label>
                  描边大小:
                  <input 
                    type="range" 
                    min="1" 
                    max="20" 
                    v-model="strokeOptions.size" 
                  />
                  {{ strokeOptions.size }}px
                </label>
              </div>
              
              <div class="stroke-option">
                <label>
                  渐变强度:
                  <input 
                    type="range" 
                    min="0" 
                    max="100" 
                    v-model="strokeOptions.gradientIntensity" 
                  />
                  {{ strokeOptions.gradientIntensity }}%
                </label>
              </div>
              
              <div class="stroke-option">
                <label>
                  描边颜色:
                  <input 
                    type="color" 
                    v-model="strokeOptions.color" 
                    class="color-picker"
                  />
                </label>
              </div>
              
              <div class="stroke-actions">
                <button 
                  class="apply-btn"
                  @click="applyStroke"
                  :disabled="isProcessing"
                >
                  {{ isProcessing ? '处理中...' : '应用' }}
          </button>
                <button 
                  class="cancel-btn"
                  @click="closeStrokePanel"
                >
                  取消
          </button>
        </div>
            </div>
        </div>
      </div>
    </div>
    
    <!-- 混合模式模块 -->
      <div class="module-card" v-if="imageLoaded">
      <h3 class="module-title">混合模式</h3>
        <select v-model="blendMode" @change="updateBlendMode" class="blend-select">
          <option value="normal">正常</option>
          <option value="multiply">正片叠底</option>
          <option value="screen">滤色</option>
          <option value="overlay">叠加</option>
          <option value="darken">变暗</option>
          <option value="lighten">变亮</option>
          <option value="color-dodge">颜色减淡</option>
          <option value="color-burn">颜色加深</option>
          <option value="hard-light">强光</option>
          <option value="soft-light">柔光</option>
          <option value="difference">差值</option>
          <option value="exclusion">排除</option>
        </select>
    </div>
    
    <!-- 滤镜效果模块 -->
      <div class="module-card" v-if="imageLoaded">
      <h3 class="module-title">滤镜效果</h3>
      <div class="filter-controls">
        <div class="filter-item">
          <label>高斯模糊</label>
          <input 
            type="range" 
            min="0" 
            max="20" 
            v-model="activeFilters.blur" 
            @input="updateFilters" 
          />
          <span>{{ activeFilters.blur }}px</span>
        </div>
        <div class="filter-item">
          <label>亮度</label>
          <input 
            type="range" 
            min="0" 
            max="200" 
            v-model="activeFilters.brightness" 
            @input="updateFilters" 
          />
          <span>{{ activeFilters.brightness }}%</span>
        </div>
        <div class="filter-item">
          <label>对比度</label>
          <input 
            type="range" 
            min="0" 
            max="200" 
            v-model="activeFilters.contrast" 
            @input="updateFilters" 
          />
          <span>{{ activeFilters.contrast }}%</span>
        </div>
        <div class="filter-item">
          <label>饱和度</label>
          <input 
            type="range" 
            min="0" 
            max="200" 
            v-model="activeFilters.saturation" 
            @input="updateFilters" 
          />
          <span>{{ activeFilters.saturation }}%</span>
        </div>
      </div>
    </div>
    
    <!-- 绘图工具模块 -->
      <div class="module-card" v-if="imageLoaded">
      <h3 class="module-title">绘图工具</h3>
      <div class="drawing-tools">
          <div class="button-group">
          <button 
            :class="['tool-btn', currentTool.active && currentTool.type === 'eraser' ? 'active' : '']"
            @click="toggleEraser"
          >
            {{ currentTool.active ? '使用中' : '选择' }} 橡皮擦
          </button>
        </div>
        <div v-if="currentTool.active && (currentTool.type === 'brush' || currentTool.type === 'eraser')" class="tool-options">
          <label>
            大小:
            <input 
              type="range" 
              min="1" 
              max="50" 
              v-model="currentTool.size" 
              @input="updateToolSize" 
            />
            {{ currentTool.size }}px
          </label>
          <label v-if="currentTool.type === 'eraser'">
            硬度:
            <input 
              type="range" 
              min="0" 
              max="100" 
              v-model="currentTool.hardness" 
              @input="updateToolHardness" 
            />
            {{ currentTool.hardness }}%
          </label>
          </div>
        </div>
      </div>
    </div>

    <!-- 右侧画布区域 -->
    <div class="canvas-area">
      <!-- 顶部工具栏 -->
      <div class="top-toolbar">
        <button @click="triggerFileInput" class="tool-btn upload-btn" :disabled="!imageLoaded && layers.length >= 1">
          <span class="icon">+</span> {{ layers.length === 0 ? '上传图片' : '添加图层' }}
          </button>
        <button @click="undoLastOperation" class="tool-btn" :disabled="canvasHistory.length === 0">
          <span class="icon">↩</span> 撤销
          </button>
        <button @click="resetCanvas" class="tool-btn" :disabled="!imageLoaded">
          <span class="icon">⟲</span> 重置
          </button>
        <button @click="downloadImage" class="tool-btn" :disabled="!imageLoaded">
          <span class="icon">↓</span> 下载
          </button>
        <div class="zoom-controls">
          <button @click="zoomOut" class="tool-btn">-</button>
          <span>{{ zoomLevel }}%</span>
          <button @click="zoomIn" class="tool-btn">+</button>
          <button @click="resetZoom" class="tool-btn">重置</button>
        </div>
          </div>
          
      <!-- 画布容器 -->
      <div class="canvas-container">
        <div class="canvas-wrapper">
          <canvas 
            ref="canvas" 
            class="main-canvas"
            @mousedown="startDraw"
            @touchstart="handleTouchStart"
            @mousemove="drawing"
            @touchmove="handleTouchMove"
            @mouseup="endDraw"
            @touchend="endDraw"
            @mouseleave="endDraw"
          ></canvas>
          <canvas ref="tempCanvas" style="display: none;"></canvas>
          </div>
        <div class="canvas-grid"></div>
          </div>
          
      <!-- 底部状态栏 -->
      <div class="bottom-statusbar" v-if="imageLoaded">
        <div class="status-item">
          <span class="status-label">显示尺寸:</span>
          <span class="status-value">{{ displayCanvasSize }}×{{ displayCanvasSize }}px</span>
          </div>
        <div class="status-item">
          <span class="status-label">导出尺寸:</span>
          <span class="status-value">{{ highResCanvasSize }}×{{ highResCanvasSize }}px</span>
        </div>
        <div class="status-item" v-if="layers.length > 0">
          <span class="status-label">当前图层:</span>
          <span class="status-value">{{ activeLayerIndex + 1 }}/{{ layers.length }}</span>
          </div>
        </div>

      <!-- 文件上传输入框（隐藏） -->
              <input 
                type="file" 
                accept="image/*"
        ref="fileInput" 
        @change="handleFileUpload" 
        class="file-input"
        style="display: none;"
              />
          </div>
          
    <!-- 填充图层选项 -->
    <div class="fill-layer-options" v-if="showFillLayerOptions">
      <div class="option-panel">
        <div class="option-header">
          <h4 class="option-title">填充图层选项</h4>
          <button class="close-btn" @click="closeFillLayerOptions">&times;</button>
        </div>
        <div class="option-content">
          <div class="form-group">
            <label class="form-label">填充类型:</label>
            <div class="fill-type-buttons">
            <button 
                class="fill-type-btn" 
                :class="{ active: fillLayerOptions.type === 'color' }"
                @click="fillLayerOptions.type = 'color'"
            >
                纯色填充
            </button>
            <button 
                class="fill-type-btn" 
                :class="{ active: fillLayerOptions.type === 'image' }"
                @click="fillLayerOptions.type = 'image'"
            >
                图片填充
            </button>
          </div>
        </div>
        
          <div class="form-group" v-if="fillLayerOptions.type === 'color'">
            <label class="form-label">填充颜色:</label>
            <div class="color-picker-wrapper">
              <input type="color" v-model="fillLayerOptions.color" class="color-picker" />
              <span class="color-value">{{ fillLayerOptions.color }}</span>
          </div>
          </div>
          
          <div class="form-group" v-if="fillLayerOptions.type === 'image'">
            <label class="form-label">填充图片:</label>
            <div class="image-upload-wrapper">
              <input 
                type="file" 
                id="fillImage" 
                @change="handleFillImageUpload" 
                accept="image/*"
                class="file-input"
              />
              <label for="fillImage" class="upload-btn">
                选择图片
            </label>
              <div class="preview-wrapper" v-if="fillLayerOptions.previewUrl">
                <img :src="fillLayerOptions.previewUrl" alt="预览" class="preview-image" />
            </div>
          </div>
          </div>
        </div>
        
        <div class="option-footer">
          <button class="apply-btn" @click="applyFillLayer">应用</button>
          <button class="cancel-btn" @click="closeFillLayerOptions">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { presetActions, executePreset } from '@/presets';
import lookIcon from '@/assets/icon/look.svg';
import unlookIcon from '@/assets/icon/unlook.svg';
import deleateIcon from '@/assets/icon/deleate.svg';

export default {
  name: 'HomeView',
  
  data() {
    return {
      // 移动端适配相关
      isMobileView: false,
      sidebarVisible: true,
      
      // 图片和画布相关
      originalImage: null,
      ctx: null,
      tempCtx: null,
      imageLoaded: false,
      imageWidth: 0,
      imageHeight: 0,
      
      // 图层系统
      layers: [],
      activeLayerIndex: -1,
      nextLayerId: 1,
      
      // 图层画布缓存
      layerCanvases: {}, // 存储每个图层的离屏画布
      highResLayerCanvases: {}, // 存储高分辨率图层画布
      
      // 画布尺寸
      displayCanvasSize: 800, // 默认显示尺寸
      highResCanvasSize: 3000, // 高分辨率尺寸
      
      // 预设动作
      presetActions: presetActions,
      selectedPreset: null,
      isExecutingPreset: false,
      
      // 历史状态
      canvasHistory: [],
      maxHistorySteps: 10,
      
      // 工具参数
      blurLevel: 0,
      opacity: 100,
      scale: 100,
      
      // 绘图状态
      isDrawing: false,
      lastX: 0,
      lastY: 0,
      currentTool: {
        type: 'eraser',
        size: 10,
        hardness: 50,
        active: false
      },
      
      // 滤镜状态
      activeFilters: {
        blur: 0,
        brightness: 100,
        contrast: 100,
        saturation: 100
      },
      
      // 混合模式
      blendMode: 'normal',
      
      // 图层工具选项
      showStrokeOptions: false,
      strokeOptions: {
        size: 3,
        color: '#ffffff',
        gradientIntensity: 50 // 添加渐变强度选项，默认50%
      },
      
      // 图标
      icons: {
        look: lookIcon,
        unlook: unlookIcon,
        deleate: deleateIcon
      },
      
      // 选区相关
      hasSelection: false,
      selectionData: null,
      
      // 填充选项
      showFillOptions: false,
      fillOptions: {
        color: '#ffffff'
      },
      
      // 缩放控制
      zoomLevel: 100,
      minZoom: 10,
      maxZoom: 400,
      zoomStep: 10,
      
      // 拖动相关
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      dragOffsetX: 0,
      dragOffsetY: 0,
      
      // 画布视口
      viewportWidth: 0,
      viewportHeight: 0,
      
      // 图层移动控制
      showLayerMoveControls: false,
      
      // 填充图层选项
      showFillLayerOptions: false,
      fillLayerOptions: {
        type: 'color',
        color: '#ffffff',
        image: null,
        previewUrl: null
      },
      isSpacePressed: false, // 添加空格键状态
      showStrokePanel: false,
      isProcessing: false,
    }
  },
  mounted() {
    // 初始化画布
    this.initCanvas();
    
    // 检测窗口大小变化
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
    
    // 添加鼠标滚轮事件监听
    this.$refs.canvas.addEventListener('wheel', this.handleWheel, { passive: false });
    
    // 添加键盘事件监听
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('keyup', this.handleKeyUp);
  },
  beforeUnmount() {
    // 移除事件监听器
    window.removeEventListener('resize', this.checkScreenSize);
    this.$refs.canvas.removeEventListener('wheel', this.handleWheel);
    
    // 移除键盘事件监听
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('keyup', this.handleKeyUp);
  },
  methods: {
    checkScreenSize() {
      // 更新视口尺寸
      this.viewportWidth = window.innerWidth - 320; // 减去侧边栏宽度
      this.viewportHeight = window.innerHeight - 80; // 减去顶部和底部工具栏高度
      
      // 如果屏幕宽度小于768px，认为是移动设备
      this.isMobileView = window.innerWidth < 768;
      this.sidebarVisible = !this.isMobileView;
      
      // 调整画布位置
      this.centerCanvas();
    },
    
    toggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    },
    
    initCanvas() {
      const canvas = this.$refs.canvas;
      const tempCanvas = this.$refs.tempCanvas;
      
      // 设置画布尺寸
      canvas.width = this.displayCanvasSize;
      canvas.height = this.displayCanvasSize;
      tempCanvas.width = this.displayCanvasSize;
      tempCanvas.height = this.displayCanvasSize;
      
      this.ctx = canvas.getContext('2d');
      this.tempCtx = tempCanvas.getContext('2d');
      
      // 绘制背景
      this.drawCheckerboard();
      
      // 居中画布
      this.centerCanvas();
    },
    
    centerCanvas() {
      if (!this.imageLoaded) return;
      
      // 计算缩放比例,使画布适应视口
      const scaleX = this.viewportWidth / this.displayCanvasSize;
      const scaleY = this.viewportHeight / this.displayCanvasSize;
      const scale = Math.min(scaleX, scaleY) * 0.9; // 留出一些边距
      
      // 更新缩放级别
      this.zoomLevel = Math.min(Math.max(scale * 100, this.minZoom), this.maxZoom);
      
      // 重置拖动偏移
      this.dragOffsetX = 0;
      this.dragOffsetY = 0;
      
      // 重绘画布
      this.redrawCanvas();
    },
    
    handleWheel(e) {
      e.preventDefault();
      
      if (e.ctrlKey || e.metaKey) {
        // 缩放
        const delta = e.deltaY > 0 ? -this.zoomStep : this.zoomStep;
        const oldZoom = this.zoomLevel;
        this.zoomLevel = Math.min(Math.max(this.zoomLevel + delta, this.minZoom), this.maxZoom);
        
        if (oldZoom !== this.zoomLevel) {
          // 计算鼠标位置相对于画布的偏移
          const rect = this.$refs.canvas.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          
          // 调整拖动偏移以保持鼠标位置不变
          const scale = this.zoomLevel / oldZoom;
          this.dragOffsetX = x - (x - this.dragOffsetX) * scale;
          this.dragOffsetY = y - (y - this.dragOffsetY) * scale;
          
          this.redrawCanvas();
        }
      } else {
        // 平移
        const deltaX = e.deltaX;
        const deltaY = e.deltaY;
        
        this.dragOffsetX -= deltaX;
        this.dragOffsetY -= deltaY;
        
        this.redrawCanvas();
      }
    },
    
    drawCheckerboard() {
      // 绘制棋盘格背景表示透明区域
      const canvas = this.$refs.canvas;
      const squareSize = 10;
      this.ctx.fillStyle = '#f0f0f0';
      this.ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      this.ctx.fillStyle = '#e0e0e0';
      for (let x = 0; x < canvas.width; x += squareSize) {
        for (let y = 0; y < canvas.height; y += squareSize) {
          if ((x / squareSize + y / squareSize) % 2 === 0) {
            this.ctx.fillRect(x, y, squareSize, squareSize);
          }
        }
      }
    },
    
    saveCanvasState() {
      // 保存当前状态到历史记录
      console.log('Saving canvas state...');
      
      // 创建所有图层画布的深拷贝
      const layerCanvasesState = {};
      const highResLayerCanvasesState = {};
      
      // 保存每个图层的画布状态
      for (const layerId in this.layerCanvases) {
        const originalCanvas = this.layerCanvases[layerId];
        const highResCanvas = this.highResLayerCanvases[layerId];
        
        // 创建新的画布并复制内容 - 显示画布
        if (originalCanvas) {
          const tempCanvas = document.createElement('canvas');
          tempCanvas.width = originalCanvas.width;
          tempCanvas.height = originalCanvas.height;
          
          const tempCtx = tempCanvas.getContext('2d');
          tempCtx.drawImage(originalCanvas, 0, 0);
          
          layerCanvasesState[layerId] = tempCanvas.toDataURL('image/png');
        }
        
        // 保存高分辨率画布状态 - 只存储参考，不保存完整数据避免内存占用过大
        if (highResCanvas) {
          highResLayerCanvasesState[layerId] = true;
        }
      }
      
      // 保存图层数据结构的拷贝和图层画布状态
      const state = {
        layers: JSON.parse(JSON.stringify(this.layers)),
        layerCanvases: layerCanvasesState,
        highResLayerCanvases: highResLayerCanvasesState,
        activeLayerIndex: this.activeLayerIndex
      };
      
      this.canvasHistory.push(state);
      console.log('State saved. History length:', this.canvasHistory.length);
      
      // 限制历史记录长度
      if (this.canvasHistory.length > this.maxHistorySteps) {
        this.canvasHistory.shift();
      }
    },
    
    undoLastOperation() {
      if (this.canvasHistory.length === 0) {
        console.log('No history to undo');
        return;
      }
      
      console.log('Undoing last operation...');
      
      // 从历史记录中恢复上一步
      const previousState = this.canvasHistory.pop();
      
      // 恢复图层状态
      this.layers = previousState.layers;
      this.activeLayerIndex = previousState.activeLayerIndex;
      
      console.log('Restoring layers:', this.layers.length, 'Active layer:', this.activeLayerIndex);
      
      // 恢复每个图层的画布
      this.layerCanvases = {};
      this.highResLayerCanvases = {};
      
      // 重新创建每个图层的画布
      let loadedCount = 0;
      const totalLayers = Object.keys(previousState.layerCanvases).length;
      
      for (const layerId in previousState.layerCanvases) {
        const imageData = previousState.layerCanvases[layerId];
        const img = new Image();
        
        img.onload = () => {
          // 恢复显示画布
          const canvas = document.createElement('canvas');
          canvas.width = this.displayCanvasSize;
          canvas.height = this.displayCanvasSize;
          
          const ctx = canvas.getContext('2d');
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0);
          
          this.layerCanvases[layerId] = canvas;
          
          // 创建对应的高分辨率画布
          this.createHighResCanvasFromDisplay(layerId);
          
          loadedCount++;
          console.log(`Loaded layer canvas ${loadedCount}/${totalLayers}`);
          
          // 当所有图层画布都加载完成后重绘主画布
          if (loadedCount === totalLayers) {
            console.log('All layer canvases restored, redrawing...');
            this.redrawCanvas();
            
            // 更新当前图层的UI状态
            if (this.activeLayerIndex >= 0 && this.activeLayerIndex < this.layers.length) {
              const activeLayer = this.layers[this.activeLayerIndex];
              this.activeFilters = { ...activeLayer.filters };
              this.blendMode = activeLayer.blendMode;
            }
          }
        };
        
        img.src = imageData;
      }
    },
    
    createHighResCanvasFromDisplay(layerId) {
      // 从显示画布创建高分辨率画布
      const displayCanvas = this.layerCanvases[layerId];
      if (!displayCanvas) return;
      
      const highResCanvas = document.createElement('canvas');
      highResCanvas.width = this.highResCanvasSize;
      highResCanvas.height = this.highResCanvasSize;
      
      const ctx = highResCanvas.getContext('2d');
      ctx.clearRect(0, 0, highResCanvas.width, highResCanvas.height);
      
      // 将显示画布的内容缩放到高分辨率画布
      ctx.drawImage(
        displayCanvas,
        0, 0, displayCanvas.width, displayCanvas.height,
        0, 0, highResCanvas.width, highResCanvas.height
      );
      
      this.highResLayerCanvases[layerId] = highResCanvas;
    },
    
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file || !file.type.includes('image')) {
        alert('请选择有效的图片文件!');
        return;
      }
      
      const reader = new FileReader();
      reader.onload = (e) => {
        const newImage = new Image();
        newImage.onload = () => {
          // 如果是第一张图片，初始化画布
          if (this.layers.length === 0) {
            // 保持原始图片尺寸信息
            this.imageWidth = newImage.width;
            this.imageHeight = newImage.height;
            this.imageLoaded = true;
            
            // 清空历史记录
            this.canvasHistory = [];
          }
          
          // 创建新图层
          this.addNewLayer(newImage, file.name);
        };
        newImage.src = e.target.result;
      };
      reader.readAsDataURL(file);
      
      // 清空input以便再次选择同一文件
      event.target.value = '';
    },
    
    addNewLayer(image, fileName) {
      // 创建图层缩略图
      const thumbnail = this.createThumbnail(image);
      
      // 创建新图层ID
      const layerId = this.nextLayerId++;
      
      // 为图层创建一个离屏画布
      this.createLayerCanvas(layerId, image);
      
      // 添加新图层到图层列表
      const newLayer = {
        id: layerId,
        name: this.getLayerName(fileName),
        image: image,
        visible: true,
        opacity: 100,
        blendMode: 'normal',
        filters: {
          blur: 0,
          brightness: 100,
          contrast: 100,
          saturation: 100
        },
        thumbnail: thumbnail,
        offsetX: 0,  // 初始化偏移量
        offsetY: 0
      };
      
      // 将新图层添加到数组的开头（最上层）而不是结尾
      this.layers.unshift(newLayer);
      
      // 设置当前图层为新添加的图层（现在是索引0）
      this.activeLayerIndex = 0;
      
      // 更新活动图层的滤镜和混合模式
      this.updateActiveLayerFilters();
      this.updateActiveLayerBlendMode();
      
      // 保存当前状态以支持撤销操作
      this.saveCanvasState();
      
      // 重绘画布
      this.redrawCanvas();
    },
    
    createLayerCanvas(layerId, image) {
      // 创建一个新的离屏画布来存储该图层的绘图内容 (用于显示)
      const layerCanvas = document.createElement('canvas');
      layerCanvas.width = this.displayCanvasSize;
      layerCanvas.height = this.displayCanvasSize;
      
      const ctx = layerCanvas.getContext('2d');
      
      // 绘制透明背景
      ctx.clearRect(0, 0, layerCanvas.width, layerCanvas.height);
      
      // 如果有初始图像，绘制到图层画布上
      if (image) {
        // 获取图像的原始尺寸
        const imgWidth = image.width;
        const imgHeight = image.height;
        
        // 计算居中位置，不进行缩放，保持原比例
        const centerX = (layerCanvas.width - imgWidth) / 2;
        const centerY = (layerCanvas.height - imgHeight) / 2;
        
        // 如果图像太大，超出画布，才进行适度缩放
        if (imgWidth > layerCanvas.width || imgHeight > layerCanvas.height) {
          // 计算缩放比例，使图片适应画布
          const hRatio = layerCanvas.width / imgWidth;
          const vRatio = layerCanvas.height / imgHeight;
          const ratio = Math.min(hRatio, vRatio);
          
          // 按比例缩放后的尺寸
          const scaledWidth = imgWidth * ratio;
          const scaledHeight = imgHeight * ratio;
          
          // 计算居中位置
          const scaledCenterX = (layerCanvas.width - scaledWidth) / 2;
          const scaledCenterY = (layerCanvas.height - scaledHeight) / 2;
          
          // 绘制图像到图层画布
          ctx.drawImage(
            image, 
            0, 0, imgWidth, imgHeight,
            scaledCenterX, scaledCenterY, scaledWidth, scaledHeight
          );
        } else {
          // 图像不需要缩放，直接绘制
          ctx.drawImage(image, centerX, centerY);
        }
      }
      
      // 将创建的画布存储到图层画布缓存中
      this.layerCanvases[layerId] = layerCanvas;
      
      // 同时创建高分辨率版本
      this.createHighResLayerCanvas(layerId, image);
      
      return layerCanvas;
    },
    
    createHighResLayerCanvas(layerId, image) {
      // 创建高分辨率画布
      const highResCanvas = document.createElement('canvas');
      highResCanvas.width = this.highResCanvasSize;
      highResCanvas.height = this.highResCanvasSize;
      
      const ctx = highResCanvas.getContext('2d');
      
      // 绘制透明背景
      ctx.clearRect(0, 0, highResCanvas.width, highResCanvas.height);
      
      // 如果有初始图像，绘制到高分辨率画布上
      if (image) {
        // 获取图像的原始尺寸
        const imgWidth = image.width;
        const imgHeight = image.height;
        
        // 计算在高分辨率画布上的显示比例
        const displayToHighResRatio = this.highResCanvasSize / this.displayCanvasSize;
        
        // 如果图像太大，超出原画布，使用相同的缩放策略
        if (imgWidth > this.displayCanvasSize || imgHeight > this.displayCanvasSize) {
          // 计算缩放比例，使图片适应原画布
          const hRatio = this.displayCanvasSize / imgWidth;
          const vRatio = this.displayCanvasSize / imgHeight;
          const ratio = Math.min(hRatio, vRatio);
          
          // 按比例缩放后的尺寸
          const scaledWidth = imgWidth * ratio * displayToHighResRatio;
          const scaledHeight = imgHeight * ratio * displayToHighResRatio;
          
          // 计算居中位置
          const scaledCenterX = (highResCanvas.width - scaledWidth) / 2;
          const scaledCenterY = (highResCanvas.height - scaledHeight) / 2;
          
          // 绘制图像到高分辨率画布
          ctx.drawImage(
            image, 
            0, 0, imgWidth, imgHeight,
            scaledCenterX, scaledCenterY, scaledWidth, scaledHeight
          );
        } else {
          // 图像不需要缩放，只需适应高分辨率
          const centerX = (highResCanvas.width - imgWidth * displayToHighResRatio) / 2;
          const centerY = (highResCanvas.height - imgHeight * displayToHighResRatio) / 2;
          
          ctx.drawImage(
            image, 
            0, 0, imgWidth, imgHeight,
            centerX, centerY, imgWidth * displayToHighResRatio, imgHeight * displayToHighResRatio
          );
        }
      }
      
      // 存储高分辨率画布
      this.highResLayerCanvases[layerId] = highResCanvas;
    },
    
    getActiveLayerCanvas() {
      // 获取当前活动图层的画布
      if (this.activeLayerIndex >= 0 && this.activeLayerIndex < this.layers.length) {
        const activeLayer = this.layers[this.activeLayerIndex];
        return this.layerCanvases[activeLayer.id];
      }
      return null;
    },
    
    getLayerName(fileName) {
      // 从文件名生成图层名
      if (fileName) {
        const name = fileName.split('.')[0];
        return name.length > 15 ? name.substring(0, 15) + '...' : name;
      }
      return `图层 ${this.nextLayerId}`;
    },
    
    createThumbnail(image) {
      // 创建图层缩略图
      const canvas = document.createElement('canvas');
      const size = 50; // 缩略图大小
      canvas.width = size;
      canvas.height = size;
      
      const ctx = canvas.getContext('2d');
      
      // 计算缩放比例，使图片适应缩略图
      const hRatio = size / image.width;
      const vRatio = size / image.height;
      const ratio = Math.min(hRatio, vRatio);
      
      // 计算居中位置
      const centerX = (size - image.width * ratio) / 2;
      const centerY = (size - image.height * ratio) / 2;
      
      // 绘制灰白相间的背景表示透明
      ctx.fillStyle = '#f0f0f0';
      ctx.fillRect(0, 0, size, size);
      
      ctx.fillStyle = '#e0e0e0';
      const squareSize = 5;
      for (let x = 0; x < size; x += squareSize) {
        for (let y = 0; y < size; y += squareSize) {
          if ((x / squareSize + y / squareSize) % 2 === 0) {
            ctx.fillRect(x, y, squareSize, squareSize);
          }
        }
      }
      
      // 绘制缩略图
      ctx.drawImage(
        image, 
        0, 0, image.width, image.height,
        centerX, centerY, image.width * ratio, image.height * ratio
      );
      
      return canvas.toDataURL('image/png');
    },
    
    setActiveLayer(index) {
      if (index >= 0 && index < this.layers.length) {
        // 保存当前状态
        this.saveCanvasState();
        
        this.activeLayerIndex = index;
        
        // 更新UI以反映当前图层的设置
        const activeLayer = this.layers[this.activeLayerIndex];
        this.blendMode = activeLayer.blendMode;
        this.activeFilters = { ...activeLayer.filters };
        
        // 重绘画布
        this.redrawCanvas();
        
        // 如果存在选区，重新显示选区
        if (this.hasSelection) {
          this.showSelection();
        }
      }
    },
    
    toggleLayerVisibility(index) {
      if (index >= 0 && index < this.layers.length) {
        // 保存当前状态
        this.saveCanvasState();
        
        // 切换可见性
        this.layers[index].visible = !this.layers[index].visible;
        
        // 重绘画布
        this.redrawCanvas();
      }
    },
    
    updateLayerOpacity(index) {
      if (index >= 0 && index < this.layers.length) {
        // 保存当前状态
        this.saveCanvasState();
        
        // 重绘画布
        this.redrawCanvas();
      }
    },
    
    deleteLayer(index) {
      if (index >= 0 && index < this.layers.length) {
        // 保存当前状态
        this.saveCanvasState();
        
        // 获取要删除的图层ID
        const layerId = this.layers[index].id;
        
        // 删除图层
        this.layers.splice(index, 1);
        
        // 从缓存中删除图层画布
        delete this.layerCanvases[layerId];
        
        // 调整活动图层索引
        if (this.layers.length === 0) {
          this.activeLayerIndex = -1;
          this.imageLoaded = false;
        } else if (this.activeLayerIndex >= this.layers.length) {
          this.activeLayerIndex = this.layers.length - 1;
        }
        
        // 重绘画布
        this.redrawCanvas();
      }
    },
    
    // 图层排序方法
    moveLayerUp(index) {
      if (index <= 0 || index >= this.layers.length) return;
      
      // 保存当前状态
      this.saveCanvasState();
      
      // 交换当前图层和上一个图层
      const temp = this.layers[index];
      this.layers[index] = this.layers[index - 1];
      this.layers[index - 1] = temp;
      
      // 如果当前选中的是被移动的图层，更新选中索引
      if (this.activeLayerIndex === index) {
        this.activeLayerIndex = index - 1;
      } else if (this.activeLayerIndex === index - 1) {
        this.activeLayerIndex = index;
      }
      
      // 重绘画布
      this.redrawCanvas();
    },
    
    moveLayerDown(index) {
      if (index < 0 || index >= this.layers.length - 1) return;
      
      // 保存当前状态
      this.saveCanvasState();
      
      // 交换当前图层和下一个图层
      const temp = this.layers[index];
      this.layers[index] = this.layers[index + 1];
      this.layers[index + 1] = temp;
      
      // 如果当前选中的是被移动的图层，更新选中索引
      if (this.activeLayerIndex === index) {
        this.activeLayerIndex = index + 1;
      } else if (this.activeLayerIndex === index + 1) {
        this.activeLayerIndex = index;
      }
      
      // 重绘画布
      this.redrawCanvas();
    },
    
    drawImage() {
      // 重绘所有图层
      this.redrawCanvas();
    },
    
    updateBlendMode(event) {
      if (this.activeLayerIndex < 0 || !this.imageLoaded) return;
      
      try {
        // 保存当前状态
        this.saveCanvasState();
        
        // 更新当前图层的混合模式
        this.blendMode = event.target.value;
        this.updateActiveLayerBlendMode();
        
        // 重绘画布
        this.redrawCanvas();
      } catch (error) {
        console.error('更新混合模式时出错:', error);
      }
    },
    
    updateActiveLayerBlendMode() {
      if (this.activeLayerIndex < 0 || this.activeLayerIndex >= this.layers.length) {
        console.warn('没有选中的图层，无法应用混合模式');
        return;
      }
      
      const activeLayer = this.layers[this.activeLayerIndex];
      if (!activeLayer) {
        console.warn('选中的图层无效');
        return;
      }
      
      // 更新图层的混合模式
      activeLayer.blendMode = this.blendMode;
      
      console.log('已更新图层混合模式:', activeLayer.blendMode);
    },
    
    updateFilters() {
      if (this.activeLayerIndex < 0 || !this.imageLoaded) return;
      
      try {
        // 保存当前状态
        this.saveCanvasState();
        
        // 更新当前图层的滤镜
        this.updateActiveLayerFilters();
        
        // 重绘画布
        this.redrawCanvas();
      } catch (error) {
        console.error('更新滤镜时出错:', error);
      }
    },
    
    updateActiveLayerFilters() {
      if (this.activeLayerIndex < 0 || this.activeLayerIndex >= this.layers.length) {
        console.warn('没有选中的图层，无法应用滤镜');
        return;
      }
      
      const activeLayer = this.layers[this.activeLayerIndex];
      if (!activeLayer) {
        console.warn('选中的图层无效');
        return;
      }
      
      if (!activeLayer.filters) {
        activeLayer.filters = {
          blur: 0,
          brightness: 100,
          contrast: 100,
          saturation: 100
        };
      }
      
      // 更新图层的滤镜设置
      activeLayer.filters = { ...this.activeFilters };
      
      console.log('已更新图层滤镜:', activeLayer.filters);
    },
    
    redrawCanvas() {
      // 清除画布
      this.ctx.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
      this.drawCheckerboard();
      
      // 如果没有图层，退出
      if (this.layers.length === 0) return;
      
      // 计算缩放和位置
      const zoomFactor = this.zoomLevel / 100;
      const displaySize = this.displayCanvasSize;
      const scaledSize = displaySize * zoomFactor;
      
      // 从下到上渲染每个图层
      for (let i = this.layers.length - 1; i >= 0; i--) {
        const layer = this.layers[i];
        if (!layer.visible) continue;
        
        const layerCanvas = this.layerCanvases[layer.id];
        if (!layerCanvas) continue;
        
        // 设置混合模式和透明度
        this.ctx.globalCompositeOperation = layer.blendMode;
        this.ctx.globalAlpha = layer.opacity / 100;
        
        // 应用滤镜
        let filterString = '';
        if (layer.filters.blur > 0) {
          filterString += `blur(${layer.filters.blur}px) `;
        }
        if (layer.filters.brightness !== 100) {
          filterString += `brightness(${layer.filters.brightness}%) `;
        }
        if (layer.filters.contrast !== 100) {
          filterString += `contrast(${layer.filters.contrast}%) `;
        }
        if (layer.filters.saturation !== 100) {
          filterString += `saturate(${layer.filters.saturation}%) `;
        }
        
        if (filterString) {
          this.ctx.filter = filterString;
        }
        
        // 计算图层位置
        const offsetX = layer.offsetX || 0;
        const offsetY = layer.offsetY || 0;
        
        // 计算最终位置（包括缩放、拖动和图层偏移）
        const finalX = (this.$refs.canvas.width - scaledSize) / 2 + this.dragOffsetX + (offsetX * zoomFactor);
        const finalY = (this.$refs.canvas.height - scaledSize) / 2 + this.dragOffsetY + (offsetY * zoomFactor);
        
        // 绘制图层
        this.ctx.drawImage(
          layerCanvas, 
          0, 0, layerCanvas.width, layerCanvas.height,
          finalX, finalY, scaledSize, scaledSize
        );
        
        // 重置设置
        this.ctx.filter = 'none';
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.globalAlpha = 1;
      }
    },
    
    applyCurrentFilters() {
      // 已被图层系统替代
      this.updateActiveLayerFilters();
      this.redrawCanvas();
    },
    
    resetEditState() {
      // 重置当前图层的参数
      if (this.activeLayerIndex >= 0) {
        const activeLayer = this.layers[this.activeLayerIndex];
        activeLayer.filters = {
          blur: 0,
          brightness: 100,
          contrast: 100,
          saturation: 100
        };
        activeLayer.blendMode = 'normal';
        
        // 同步UI
        this.activeFilters = { ...activeLayer.filters };
        this.blendMode = activeLayer.blendMode;
      } else {
        // 重置通用参数
        this.activeFilters = {
          blur: 0,
          brightness: 100,
          contrast: 100,
          saturation: 100
        };
        this.blendMode = 'normal';
      }
    },
    
    resetCanvas() {
      if (this.layers.length === 0) return;
      
      console.log('Resetting canvas...');
      
      // 保存当前状态
      this.saveCanvasState();
      
      try {
        // 重置所有图层
        for (let i = 0; i < this.layers.length; i++) {
          const layer = this.layers[i];
          
          // 重置图层参数
          layer.filters = {
            blur: 0,
            brightness: 100,
            contrast: 100,
            saturation: 100
          };
          layer.blendMode = 'normal';
          layer.opacity = 100;
          
          // 重新创建图层画布，使用原始图像
          if (layer.image) {
            // 完全重新创建图层画布
            const layerCanvas = document.createElement('canvas');
            layerCanvas.width = this.$refs.canvas.width;
            layerCanvas.height = this.$refs.canvas.height;
            
            const ctx = layerCanvas.getContext('2d');
            
            // 清除画布
            ctx.clearRect(0, 0, layerCanvas.width, layerCanvas.height);
            
            // 获取图像的原始尺寸
            const imgWidth = layer.image.width;
            const imgHeight = layer.image.height;
            
            // 计算居中位置，不进行缩放，保持原比例
            const centerX = (layerCanvas.width - imgWidth) / 2;
            const centerY = (layerCanvas.height - imgHeight) / 2;
            
            // 如果图像太大，超出画布，才进行适度缩放
            if (imgWidth > layerCanvas.width || imgHeight > layerCanvas.height) {
              // 计算缩放比例，使图片适应画布
              const hRatio = layerCanvas.width / imgWidth;
              const vRatio = layerCanvas.height / imgHeight;
              const ratio = Math.min(hRatio, vRatio);
              
              // 按比例缩放后的尺寸
              const scaledWidth = imgWidth * ratio;
              const scaledHeight = imgHeight * ratio;
              
              // 计算居中位置
              const scaledCenterX = (layerCanvas.width - scaledWidth) / 2;
              const scaledCenterY = (layerCanvas.height - scaledHeight) / 2;
              
              // 绘制原始图像到图层画布
              ctx.drawImage(
                layer.image, 
                0, 0, imgWidth, imgHeight,
                scaledCenterX, scaledCenterY, scaledWidth, scaledHeight
              );
            } else {
              // 图像不需要缩放，直接绘制
              ctx.drawImage(layer.image, centerX, centerY);
            }
            
            // 替换原有的图层画布
            this.layerCanvases[layer.id] = layerCanvas;
            
            // 更新图层缩略图
            this.updateLayerThumbnail(i);
          }
        }
        
        // 重置UI参数
        if (this.activeLayerIndex >= 0) {
          this.activeFilters = {
            blur: 0,
            brightness: 100,
            contrast: 100,
            saturation: 100
          };
          this.blendMode = 'normal';
        }
        
        // 重绘画布
        this.redrawCanvas();
        
        console.log('Canvas reset completed');
      } catch (e) {
        console.error('Error during canvas reset:', e);
      }
    },
    
    downloadImage() {
      if (!this.imageLoaded) return;

      try {
        // 提供多种下载选项
        const options = ['当前画布尺寸', '原始图像尺寸', '自定义尺寸'];
        let choice = -1;
        
        do {
          const input = prompt(
            `请选择导出尺寸选项 (输入数字):\n` +
            `1. 当前画布尺寸 (${this.displayCanvasSize}×${this.displayCanvasSize}像素)\n` +
            `2. 原始图像尺寸 (${this.imageWidth}×${this.imageHeight}像素)\n` + 
            `3. 自定义尺寸`,
            '1'
          );
          
          // 用户取消
          if (input === null) return;
          
          choice = parseInt(input);
        } while (isNaN(choice) || choice < 1 || choice > options.length);
        
        // 确定导出尺寸
        let exportWidth, exportHeight;
        
        if (choice === 1) {
          // 当前画布尺寸
          exportWidth = this.displayCanvasSize;
          exportHeight = this.displayCanvasSize;
        } else if (choice === 2) {
          // 原始图像尺寸
          exportWidth = this.imageWidth;
          exportHeight = this.imageHeight;
        } else {
          // 自定义尺寸
          const size = prompt('请输入导出尺寸 (例如: 1024×768):', `${this.imageWidth}×${this.imageHeight}`);
          if (!size) return; // 用户取消
          
          const dimensions = size.split(/[x×]/);
          if (dimensions.length !== 2) {
            alert('格式无效，请使用 宽度×高度 格式');
            return;
          }
          
          exportWidth = parseInt(dimensions[0]);
          exportHeight = parseInt(dimensions[1]);
          
          if (isNaN(exportWidth) || isNaN(exportHeight) || exportWidth <= 0 || exportHeight <= 0) {
            alert('请输入有效的尺寸');
            return;
          }
        }
        
        // 创建导出画布
        const exportCanvas = document.createElement('canvas');
        exportCanvas.width = exportWidth;
        exportCanvas.height = exportHeight;
        const exportCtx = exportCanvas.getContext('2d');
        
        // 优化导出画质
        exportCtx.imageSmoothingEnabled = true;
        exportCtx.imageSmoothingQuality = 'high';
        
        // 确定是否应用棋盘格透明背景
        const useTransparentBg = confirm('是否保留透明背景？点击"确定"保留透明背景，点击"取消"使用白色背景');
        
        // 设置背景
        if (!useTransparentBg) {
          // 使用白色背景
          exportCtx.fillStyle = '#ffffff';
          exportCtx.fillRect(0, 0, exportWidth, exportHeight);
        }
        
        // 计算缩放和居中参数
        const aspectRatio = this.imageWidth / this.imageHeight;
        const canvasAspectRatio = exportWidth / exportHeight;
        
        let drawWidth, drawHeight, offsetX, offsetY;
        
        if (aspectRatio > canvasAspectRatio) {
          // 图像比导出画布更宽，以宽度为准
          drawWidth = exportWidth;
          drawHeight = exportWidth / aspectRatio;
          offsetX = 0;
          offsetY = (exportHeight - drawHeight) / 2;
        } else {
          // 图像比导出画布更高，以高度为准
          drawHeight = exportHeight;
          drawWidth = exportHeight * aspectRatio;
          offsetX = (exportWidth - drawWidth) / 2;
          offsetY = 0;
        }
        
        // 从下到上渲染每个图层
        for (let i = this.layers.length - 1; i >= 0; i--) {
          const layer = this.layers[i];
          
          // 如果图层不可见，跳过
          if (!layer.visible) continue;
          
          // 获取图层对应的画布
          const layerCanvas = this.layerCanvases[layer.id];
          if (!layerCanvas) continue;
          
          // 设置混合模式和透明度
          exportCtx.globalCompositeOperation = layer.blendMode;
          exportCtx.globalAlpha = layer.opacity / 100;
          
          // 应用滤镜
          let filterString = '';
          if (layer.filters.blur > 0) {
            // 按比例缩放模糊值
            const scaledBlur = (layer.filters.blur * exportWidth) / this.displayCanvasSize;
            filterString += `blur(${scaledBlur}px) `;
          }
          if (layer.filters.brightness !== 100) {
            filterString += `brightness(${layer.filters.brightness}%) `;
          }
          if (layer.filters.contrast !== 100) {
            filterString += `contrast(${layer.filters.contrast}%) `;
          }
          if (layer.filters.saturation !== 100) {
            filterString += `saturate(${layer.filters.saturation}%) `;
          }
          
          if (filterString) {
            exportCtx.filter = filterString;
          }
          
          // 绘制图层内容到导出画布，并保持纵横比
          if (choice === 1) {
            // 当前画布尺寸 - 直接复制
            exportCtx.drawImage(layerCanvas, 0, 0, exportWidth, exportHeight);
          } else {
            // 原始图像尺寸或自定义尺寸 - 保持原图比例
            if (layer.image) {
              // 使用原始图像重新绘制以获得最佳质量
              exportCtx.drawImage(
                layer.image,
                0, 0, layer.image.width, layer.image.height,
                offsetX, offsetY, drawWidth, drawHeight
              );
            } else {
              // 没有原始图像，使用画布内容
              exportCtx.drawImage(
                layerCanvas,
                0, 0, layerCanvas.width, layerCanvas.height,
                offsetX, offsetY, drawWidth, drawHeight
              );
            }
          }
          
          // 重置设置
          exportCtx.filter = 'none';
          exportCtx.globalCompositeOperation = 'source-over';
          exportCtx.globalAlpha = 1;
        }
        
        // 选择导出质量和格式
        const formatOptions = ['PNG (无损)', 'JPEG (较小)'];
        let formatChoice = -1;
        
        do {
          const input = prompt(
            `请选择导出格式 (输入数字):\n` +
            `1. PNG (无损，支持透明)\n` +
            `2. JPEG (文件较小，不支持透明)`,
            '1'
          );
          
          // 用户取消
          if (input === null) return;
          
          formatChoice = parseInt(input);
        } while (isNaN(formatChoice) || formatChoice < 1 || formatChoice > formatOptions.length);
        
        let mimeType, quality, extension;
        
        if (formatChoice === 1) {
          // PNG
          mimeType = 'image/png';
          quality = 1.0;
          extension = 'png';
        } else {
          // JPEG
          mimeType = 'image/jpeg';
          // 提示用户选择JPEG质量
          const qualityStr = prompt('请输入JPEG质量 (1-100):', '90');
          if (!qualityStr) return; // 用户取消
          
          const qualityNum = parseInt(qualityStr);
          if (isNaN(qualityNum) || qualityNum < 1 || qualityNum > 100) {
            alert('请输入1-100之间的数字');
            return;
          }
          
          quality = qualityNum / 100;
          extension = 'jpg';
        }
        
        // 转换为Blob对象
        exportCanvas.toBlob((blob) => {
          if (!blob) {
            alert('导出图像失败，请尝试不同的尺寸或格式');
            return;
          }
          
          // 使用URL.createObjectURL创建临时URL
          const url = URL.createObjectURL(blob);
          
          // 创建文件名
          const dimensions = `${exportWidth}x${exportHeight}`;
          const fileName = `image_${dimensions}.${extension}`;
          
          // 创建下载链接
          const link = document.createElement('a');
          link.download = fileName;
          link.href = url;
          
          // 触发下载
          document.body.appendChild(link);
          link.click();
          
          // 清理DOM和释放URL
          document.body.removeChild(link);
          setTimeout(() => URL.revokeObjectURL(url), 100);
          
        }, mimeType, quality);
        
      } catch (error) {
        console.error('下载图像时出错:', error);
        alert('下载图像失败: ' + error.message);
      }
    },
    
    drawCheckerboardOnCanvas(canvas) {
      // 在指定画布上绘制棋盘格背景
      const ctx = canvas.getContext('2d');
      const squareSize = canvas.width / 30; // 根据画布大小调整格子大小
      
      ctx.fillStyle = '#f0f0f0';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      ctx.fillStyle = '#e0e0e0';
      for (let x = 0; x < canvas.width; x += squareSize) {
        for (let y = 0; y < canvas.height; y += squareSize) {
          if ((x / squareSize + y / squareSize) % 2 === 0) {
            ctx.fillRect(x, y, squareSize, squareSize);
          }
        }
      }
    },
    
    // 鼠标绘图功能
    startDraw(e) {
      // 如果当前是拖动模式，交给startDrag处理
      if (this.isSpacePressed) {
        this.startDrag(e);
        return;
      }
      
      if (!this.imageLoaded || this.activeLayerIndex < 0 || !this.currentTool.active) return;
      
      // 保存当前状态
      this.saveCanvasState();
      
      this.isDrawing = true;
      
      const rect = this.$refs.canvas.getBoundingClientRect();
      
      // 计算准确的鼠标坐标，考虑设备像素比、画布缩放和用户设置的缩放
      const scaleX = this.$refs.canvas.width / rect.width;
      const scaleY = this.$refs.canvas.height / rect.height;
      const zoomFactor = this.zoomLevel / 100;
      
      // 调整坐标以适应缩放和拖动
      const canvasCenterX = rect.width / 2;
      const canvasCenterY = rect.height / 2;
      const relativeX = (e.clientX - rect.left - canvasCenterX) / zoomFactor + canvasCenterX - this.dragOffsetX / zoomFactor;
      const relativeY = (e.clientY - rect.top - canvasCenterY) / zoomFactor + canvasCenterY - this.dragOffsetY / zoomFactor;
      
      this.lastX = relativeX * scaleX;
      this.lastY = relativeY * scaleY;
    },
    
    drawing(e) {
      // 如果当前是拖动模式，交给doDrag处理
      if (this.isDragging) {
        this.doDrag(e);
        return;
      }
      
      if (!this.isDrawing) return;
      
      const rect = this.$refs.canvas.getBoundingClientRect();
      
      // 计算准确的鼠标坐标，考虑设备像素比、画布缩放和用户设置的缩放
      const scaleX = this.$refs.canvas.width / rect.width;
      const scaleY = this.$refs.canvas.height / rect.height;
      const zoomFactor = this.zoomLevel / 100;
      
      // 调整坐标以适应缩放和拖动
      const canvasCenterX = rect.width / 2;
      const canvasCenterY = rect.height / 2;
      const relativeX = (e.clientX - rect.left - canvasCenterX) / zoomFactor + canvasCenterX - this.dragOffsetX / zoomFactor;
      const relativeY = (e.clientY - rect.top - canvasCenterY) / zoomFactor + canvasCenterY - this.dragOffsetY / zoomFactor;
      
      const x = relativeX * scaleX;
      const y = relativeY * scaleY;
      
      this.performDrawing(x, y);
    },
    
    performDrawing(x, y) {
      // 获取当前活动图层的画布
      const layerCanvas = this.getActiveLayerCanvas();
      if (!layerCanvas) return;
      
      const layerCtx = layerCanvas.getContext('2d');
      
      // 根据当前工具执行不同操作
      if (this.currentTool.type === 'eraser') {
        layerCtx.globalCompositeOperation = 'destination-out';
        // 根据硬度值设置不同的透明度
        layerCtx.globalAlpha = this.currentTool.hardness / 100;
      } else {
        layerCtx.globalCompositeOperation = 'source-over';
        layerCtx.globalAlpha = 1;
      }
      
      layerCtx.beginPath();
      layerCtx.lineWidth = this.currentTool.size;
      layerCtx.lineCap = 'round';
      layerCtx.lineJoin = 'round';
      
      if (this.currentTool.type === 'brush') {
        layerCtx.strokeStyle = '#000000';
      }
      
      layerCtx.moveTo(this.lastX, this.lastY);
      layerCtx.lineTo(x, y);
      layerCtx.stroke();
      
      // 恢复默认透明度
      layerCtx.globalAlpha = 1;
      
      this.lastX = x;
      this.lastY = y;
      
      // 同步绘制到高分辨率画布
      this.syncDrawToHighRes();
      
      // 更新当前图层的缩略图
      if (this.activeLayerIndex >= 0) {
        this.updateLayerThumbnail(this.activeLayerIndex);
      }
      
      // 重绘主画布以显示更改
      this.redrawCanvas();
    },
    
    syncDrawToHighRes() {
      // 将显示画布的内容同步到高分辨率画布
      if (this.activeLayerIndex >= 0 && this.activeLayerIndex < this.layers.length) {
        const layer = this.layers[this.activeLayerIndex];
        const displayCanvas = this.layerCanvases[layer.id];
        const highResCanvas = this.highResLayerCanvases[layer.id];
        
        if (!displayCanvas || !highResCanvas) return;
        
        // 创建新的高分辨率画布进行合成
        this.createHighResCanvasFromDisplay(layer.id);
      }
    },
    
    updateLayerThumbnail(index) {
      // 更新图层缩略图
      if (index >= 0 && index < this.layers.length) {
        const layer = this.layers[index];
        const layerCanvas = this.layerCanvases[layer.id];
        
        if (layerCanvas) {
          // 创建缩略图
          const thumbCanvas = document.createElement('canvas');
          const size = 50;
          thumbCanvas.width = size;
          thumbCanvas.height = size;
          
          const ctx = thumbCanvas.getContext('2d');
          // 绘制灰白相间的背景表示透明
          ctx.fillStyle = '#f0f0f0';
          ctx.fillRect(0, 0, size, size);
          
          ctx.fillStyle = '#e0e0e0';
          const squareSize = 5;
          for (let x = 0; x < size; x += squareSize) {
            for (let y = 0; y < size; y += squareSize) {
              if ((x / squareSize + y / squareSize) % 2 === 0) {
                ctx.fillRect(x, y, squareSize, squareSize);
              }
            }
          }
          
          // 绘制图层内容
          ctx.drawImage(layerCanvas, 0, 0, layerCanvas.width, layerCanvas.height, 0, 0, size, size);
          
          // 更新缩略图
          layer.thumbnail = thumbCanvas.toDataURL('image/png');
        }
      }
    },
    
    // eslint-disable-next-line no-unused-vars
    endDraw(e) {
      // 结束绘图或拖动
      this.isDrawing = false;
      this.isDragging = false;
      
      // 在绘图结束时更新当前图层的缩略图
      if (this.activeLayerIndex >= 0) {
        this.updateLayerThumbnail(this.activeLayerIndex);
      }
    },
    
    selectTool(toolType) {
      this.currentTool.type = toolType;
      this.currentTool.active = true;
    },
    
    toggleEraser() {
      // 如果橡皮擦当前未激活，则激活它
      // 如果已经激活，则取消激活
      this.currentTool.active = !this.currentTool.active;
      this.currentTool.type = 'eraser';
    },
    
    updateToolSize() {
      // 工具大小变化时不需要保存状态
    },
    
    updateToolHardness() {
      // 硬度变化时不需要保存状态
    },
    
    executePreset() {
      console.log('执行预设，当前选择:', this.selectedPreset, typeof this.selectedPreset);
      
      // 检查是否选择了预设动作
      if (!this.selectedPreset) {
        alert('请选择预设动作');
        return;
      }
      
      // 获取选中的预设对象
      const selectedPreset = this.presetActions.find(p => p.id === this.selectedPreset);
      console.log('获取到的预设对象:', selectedPreset);
      
      if (!selectedPreset) {
        alert('无效的预设动作');
        return;
      }
      
      // 检查图层数量是否满足要求
      if (this.layers.length < selectedPreset.requiredLayers) {
        alert(`此预设动作需要至少${selectedPreset.requiredLayers}张图片，请先上传图片`);
        return;
      }
      
      // 执行预设动作
      this.isExecutingPreset = true;
      this.saveCanvasState(); // 保存当前状态以便撤销
      
      try {
        // 创建上下文对象，包含预设动作需要的方法和数据
        const context = {
          layers: this.layers,
          layerCanvases: this.layerCanvases,
          activeLayerIndex: this.activeLayerIndex,
          updateLayerThumbnail: this.updateLayerThumbnail,
          redrawCanvas: this.redrawCanvas
        };
        
        // 使用导入的executePreset函数
        const result = executePreset(this.selectedPreset, context);
        
        if (!result) {
          console.error('预设动作执行失败');
          alert('预设动作执行失败，请查看控制台获取详细信息');
        }
      } catch (error) {
        console.error('执行预设动作时出错:', error);
        alert(`执行预设动作出错: ${error.message}`);
      } finally {
        this.isExecutingPreset = false;
      }
    },
    
    // 执行选定预设动作 (新方法)
    executeSelectedPreset() {
      if (!this.selectedPreset || this.isExecutingPreset) return;
      
      this.isExecutingPreset = true;
      
      // 保存当前状态
      this.saveCanvasState();
      
      try {
        // 执行预设动作
        executePreset(this, this.selectedPreset);
      } catch (error) {
        console.error('执行预设动作时发生错误:', error);
        alert('执行预设动作失败: ' + error.message);
      } finally {
        this.isExecutingPreset = false;
      }
    },
    
    // 缩放相关方法
    applyZoom() {
      // 应用缩放到画布
      // 重置拖动偏移，以避免放大/缩小时图像位置异常
      if (this.zoomLevel <= 100) {
        this.dragOffsetX = 0;
        this.dragOffsetY = 0;
      }
      this.redrawCanvas();
    },
    
    zoomIn() {
      // 放大画布
      this.zoomLevel = Math.min(200, this.zoomLevel + 10);
      this.applyZoom();
    },
    
    zoomOut() {
      // 缩小画布
      this.zoomLevel = Math.max(10, this.zoomLevel - 10);
      this.applyZoom();
    },
    
    resetZoom() {
      // 重置缩放级别
      this.zoomLevel = 100;
      this.dragOffsetX = 0;
      this.dragOffsetY = 0;
      this.applyZoom();
    },
    
    // 图层工具方法
    invertLayer() {
      if (this.activeLayerIndex < 0) return;
      
      // 保存当前状态
      this.saveCanvasState();
      
      // 获取当前图层的画布
      const layer = this.layers[this.activeLayerIndex];
      const layerCanvas = this.layerCanvases[layer.id];
      
      if (!layerCanvas) return;
      
      const ctx = layerCanvas.getContext('2d');
      const imageData = ctx.getImageData(0, 0, layerCanvas.width, layerCanvas.height);
      const data = imageData.data;
      
      // 反相操作
      for (let i = 0; i < data.length; i += 4) {
        // 跳过透明像素
        if (data[i + 3] === 0) continue;
        
        data[i] = 255 - data[i];         // 红
        data[i + 1] = 255 - data[i + 1]; // 绿
        data[i + 2] = 255 - data[i + 2]; // 蓝
        // 不修改 alpha 通道
      }
      
      ctx.putImageData(imageData, 0, 0);
      
      // 同步到高分辨率画布
      this.createHighResCanvasFromDisplay(layer.id);
      
      // 更新缩略图
      this.updateLayerThumbnail(this.activeLayerIndex);
      
      // 重绘主画布
      this.redrawCanvas();
    },
    
    openStrokeOptions() {
      if (this.activeLayerIndex < 0) return;
      this.showStrokePanel = true;
    },
    
    closeStrokePanel() {
      this.showStrokePanel = false;
    },
    
    applyStroke() {
      if (this.activeLayerIndex < 0 || this.isProcessing) return;
      
      // 保存当前状态
      this.saveCanvasState();
      
      // 获取当前图层的画布
      const layerCanvas = this.layerCanvases[this.layers[this.activeLayerIndex].id];
      const layerId = this.layers[this.activeLayerIndex].id;
      
      if (!layerCanvas) return;
      
      this.isProcessing = true;
      
      // 使用 requestAnimationFrame 和 Promise 进行异步处理
      requestAnimationFrame(() => {
        this.applyStrokeAsync(layerCanvas)
          .then(() => {
            // 同步到高分辨率画布
            this.createHighResCanvasFromDisplay(layerId);
            
            // 更新缩略图
            this.updateLayerThumbnail(this.activeLayerIndex);
            
            // 重绘主画布
            this.redrawCanvas();
            
            // 关闭描边面板
            this.showStrokePanel = false;
            this.isProcessing = false;
          })
          .catch(error => {
            console.error('描边处理失败:', error);
            this.isProcessing = false;
          });
      });
    },
    
    // eslint-disable-next-line no-unused-vars
    applyStrokeAsync(layerCanvas) {
      return new Promise((resolve) => {
        // 获取画布上下文
      const ctx = layerCanvas.getContext('2d');
      const strokeSize = parseInt(this.strokeOptions.size);
        const gradientIntensity = this.strokeOptions.gradientIntensity / 100;
      
      // 创建临时画布
      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = layerCanvas.width;
      tempCanvas.height = layerCanvas.height;
      const tempCtx = tempCanvas.getContext('2d');
      
      // 复制原始内容到临时画布
      tempCtx.drawImage(layerCanvas, 0, 0);
      
      // 创建描边画布
      const strokeCanvas = document.createElement('canvas');
      strokeCanvas.width = layerCanvas.width;
      strokeCanvas.height = layerCanvas.height;
      const strokeCtx = strokeCanvas.getContext('2d');
      
        // 使用 Web Worker 或者 分批处理
        // 这里我们使用分批处理的方法
        setTimeout(() => {
      // 获取原始图像数据
      const imageData = tempCtx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
      const data = imageData.data;
      
      // 创建一个新的ImageData来存储描边
      const strokeData = new ImageData(tempCanvas.width, tempCanvas.height);
      const strokePixels = strokeData.data;
      
      // 计算描边范围
      const range = strokeSize * 2;
      
          // 分批处理的高度
          const batchSize = 50; // 每批处理50行
          let currentRow = 0;
          
          const processNextBatch = () => {
            const startRow = currentRow;
            const endRow = Math.min(currentRow + batchSize, tempCanvas.height);
            
            // 处理当前批次的像素
            for (let y = startRow; y < endRow; y++) {
        for (let x = 0; x < tempCanvas.width; x++) {
          const idx = (y * tempCanvas.width + x) * 4;
          
          // 如果当前像素是非透明的
          if (data[idx + 3] > 20) {
            // 在描边范围内检查周围像素
            for (let dy = -range; dy <= range; dy++) {
              for (let dx = -range; dx <= range; dx++) {
                // 计算目标像素位置
                const targetX = x + dx;
                const targetY = y + dy;
                
                // 检查是否在画布范围内
                if (targetX >= 0 && targetX < tempCanvas.width &&
                    targetY >= 0 && targetY < tempCanvas.height) {
                  
                  // 计算到当前像素的距离
                  const distance = Math.sqrt(dx * dx + dy * dy);
                  
                  // 如果在描边范围内
                  if (distance <= range) {
                    const targetIdx = (targetY * tempCanvas.width + targetX) * 4;
                    
                    // 计算描边强度（基于距离的渐变）
                    let intensity;
                    if (gradientIntensity === 0) {
                      // 如果渐变强度为0，则使用硬边缘
                      intensity = distance <= range * 0.8 ? 1 : 0;
                    } else {
                      // 否则使用渐变效果，渐变强度影响渐变的陡峭程度
                      intensity = Math.pow(1 - (distance / range), 1 / gradientIntensity);
                    }
                    
                    // 设置描边像素
                    strokePixels[targetIdx] = 255;     // R
                    strokePixels[targetIdx + 1] = 255; // G
                    strokePixels[targetIdx + 2] = 255; // B
                    strokePixels[targetIdx + 3] = Math.max(strokePixels[targetIdx + 3], intensity * 255);
                  }
                }
              }
            }
          }
        }
      }
      
            // 更新当前行
            currentRow = endRow;
            
            // 如果还有更多行需要处理，继续处理下一批
            if (currentRow < tempCanvas.height) {
              setTimeout(processNextBatch, 0);
            } else {
              // 所有行都处理完成，绘制描边
      // 将描边数据绘制到描边画布
      strokeCtx.putImageData(strokeData, 0, 0);
      
      // 清除原画布
      ctx.clearRect(0, 0, layerCanvas.width, layerCanvas.height);
      
              // 先应用描边颜色 (重要修复：先将临时描边完全显示出来)
      strokeCtx.globalCompositeOperation = 'source-in';
              
              // 解析strokeOptions.color为RGB值
              const color = this.strokeOptions.color;
              const r = parseInt(color.substring(1, 3), 16);
              const g = parseInt(color.substring(3, 5), 16);
              const b = parseInt(color.substring(5, 7), 16);
              
              // 用rgba填充以确保透明度保持不变
              strokeCtx.fillStyle = `rgba(${r}, ${g}, ${b}, 1)`;
      strokeCtx.fillRect(0, 0, strokeCanvas.width, strokeCanvas.height);
      
              // 绘制描边到原画布 (先绘制描边)
              ctx.globalCompositeOperation = 'source-over';
      ctx.drawImage(strokeCanvas, 0, 0);
      
              // 再绘制原始内容
      ctx.globalCompositeOperation = 'source-over';
      ctx.drawImage(tempCanvas, 0, 0);
      
              // 完成
              resolve();
            }
          };
      
          // 开始处理第一批
          processNextBatch();
        }, 0);
      });
    },
    
    // 复制图层方法
    duplicateLayer(index) {
      if (index < 0 || index >= this.layers.length) return;
      
      // 保存当前状态
      this.saveCanvasState();
      
      const sourceLayer = this.layers[index];
      const sourceCanvas = this.layerCanvases[sourceLayer.id];
      
      if (!sourceCanvas) return;
      
      // 创建新的图层ID
      const newLayerId = this.nextLayerId++;
      
      // 复制画布内容
      const newCanvas = document.createElement('canvas');
      newCanvas.width = sourceCanvas.width;
      newCanvas.height = sourceCanvas.height;
      const ctx = newCanvas.getContext('2d');
      ctx.drawImage(sourceCanvas, 0, 0);
      
      // 存储新画布
      this.layerCanvases[newLayerId] = newCanvas;
      
      // 创建高分辨率版本
      this.createHighResCanvasFromDisplay(newLayerId);
      
      // 创建新图层数据
      const newLayer = {
        id: newLayerId,
        name: `${sourceLayer.name} 副本`,
        image: sourceLayer.image, // 引用相同的原始图像
        visible: true,
        opacity: sourceLayer.opacity,
        blendMode: sourceLayer.blendMode,
        filters: { ...sourceLayer.filters }, // 深拷贝滤镜设置
        thumbnail: sourceLayer.thumbnail, // 暂时使用原图层的缩略图
        offsetX: sourceLayer.offsetX || 0, // 复制偏移量
        offsetY: sourceLayer.offsetY || 0
      };
      
      // 在源图层之上插入新图层
      this.layers.splice(index, 0, newLayer);
      
      // 更新缩略图
      this.updateLayerThumbnail(index);
      
      // 选中新复制的图层
      this.activeLayerIndex = index;
      
      // 重绘画布
      this.redrawCanvas();
    },
    
    // 图层重命名方法
    renameLayer() {
      if (this.activeLayerIndex < 0 || this.activeLayerIndex >= this.layers.length) return;
      
      const layer = this.layers[this.activeLayerIndex];
      const newName = prompt('请输入新的图层名称:', layer.name);
      
      // 用户取消或输入为空，不修改
      if (newName === null || newName.trim() === '') return;
      
      // 保存当前状态
      this.saveCanvasState();
      
      // 更新图层名称
      layer.name = newName.trim();
    },
    
    // 向下合并图层
    mergeDown() {
      if (this.activeLayerIndex < 0 || this.activeLayerIndex >= this.layers.length - 1) return;
      
      // 保存当前状态
      this.saveCanvasState();
      
      const activeLayer = this.layers[this.activeLayerIndex];
      const lowerLayer = this.layers[this.activeLayerIndex + 1];
      
      if (!activeLayer.visible || !lowerLayer.visible) {
        alert('要合并的两个图层必须都是可见的');
        return;
      }
      
      // 创建临时画布
      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = this.canvasWidth;
      tempCanvas.height = this.canvasHeight;
      const tempCtx = tempCanvas.getContext('2d');
      
      // 先绘制下层图层
      tempCtx.globalAlpha = lowerLayer.opacity / 100;
      tempCtx.globalCompositeOperation = lowerLayer.blendMode || 'source-over';
      tempCtx.drawImage(
        lowerLayer.canvas, 
        lowerLayer.offsetX || 0, 
        lowerLayer.offsetY || 0
      );
      
      // 再绘制上层图层
      tempCtx.globalAlpha = activeLayer.opacity / 100;
      tempCtx.globalCompositeOperation = activeLayer.blendMode || 'source-over';
      tempCtx.drawImage(
        activeLayer.canvas, 
        activeLayer.offsetX || 0, 
        activeLayer.offsetY || 0
      );
      
      // 重置全局设置
      tempCtx.globalCompositeOperation = 'source-over';
      tempCtx.globalAlpha = 1.0;
      
      // 清空下层图层画布
      const lowerCtx = lowerLayer.canvas.getContext('2d');
      lowerCtx.clearRect(0, 0, lowerLayer.canvas.width, lowerLayer.canvas.height);
      
      // 将合并结果绘制到下层图层
      lowerCtx.drawImage(tempCanvas, 0, 0);
      
      // 更新下层图层的属性
      lowerLayer.name = `${activeLayer.name} + ${lowerLayer.name}`;
      lowerLayer.blendMode = 'source-over';
      lowerLayer.opacity = 100;
      lowerLayer.offsetX = 0;
      lowerLayer.offsetY = 0;
      
      // 移除上层图层
      this.layers.splice(this.activeLayerIndex, 1);
      
      // 更新活动图层索引
      this.activeLayerIndex = this.activeLayerIndex < this.layers.length ? this.activeLayerIndex : this.layers.length - 1;
      
      // 更新缩略图
      this.updateLayerThumbnails();
      
      // 重绘画布
      this.redrawCanvas();
    },
    
    // 显示合并可见图层选项
    showMergeOptions() {
      if (this.layers.length < 2) return;
      
      if (confirm('是否合并所有可见图层？此操作无法撤销。')) {
        this.mergeVisibleLayers();
      }
    },
    
    // 合并所有可见图层
    mergeVisibleLayers() {
      if (this.layers.length < 2) return;
      
      // 保存当前状态
      this.saveCanvasState();
      
      // 创建临时画布
      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = this.canvasWidth;
      tempCanvas.height = this.canvasHeight;
      const tempCtx = tempCanvas.getContext('2d');
      
      // 获取所有可见图层
      const visibleLayers = this.layers.filter(layer => layer.visible);
      if (visibleLayers.length === 0) return;
      
      // 将所有可见图层绘制到临时画布上
      for (let i = visibleLayers.length - 1; i >= 0; i--) {
        const layer = visibleLayers[i];
        if (layer.visible) {
          // 应用混合模式
          tempCtx.globalCompositeOperation = layer.blendMode || 'source-over';
          // 应用图层透明度
          tempCtx.globalAlpha = layer.opacity / 100;
          // 绘制图层内容
          tempCtx.drawImage(
            layer.canvas, 
            layer.offsetX || 0, 
            layer.offsetY || 0
          );
          // 重置全局设置
          tempCtx.globalCompositeOperation = 'source-over';
          tempCtx.globalAlpha = 1.0;
        }
      }
      
      // 创建合并后的新图层
      const mergedLayer = {
        id: Date.now().toString(),
        name: '合并图层',
        canvas: document.createElement('canvas'),
        visible: true,
        opacity: 100,
        blendMode: 'source-over',
        offsetX: 0,
        offsetY: 0
      };
      
      // 设置合并图层的画布尺寸
      mergedLayer.canvas.width = this.canvasWidth;
      mergedLayer.canvas.height = this.canvasHeight;
      
      // 将临时画布内容复制到合并图层
      const mergedCtx = mergedLayer.canvas.getContext('2d');
      mergedCtx.drawImage(tempCanvas, 0, 0);
      
      // 移除所有可见图层
      const newLayers = this.layers.filter(layer => !layer.visible);
      
      // 添加合并后的图层
      newLayers.push(mergedLayer);
      
      // 更新图层并设置活动图层
      this.layers = newLayers;
      this.activeLayerIndex = this.layers.length - 1;
      
      // 更新缩略图
      this.updateLayerThumbnails();
      
      // 重绘画布
      this.redrawCanvas();
    },
    
    // 全选功能
    selectAll() {
      if (this.activeLayerIndex < 0) return;
      
      // 如果已经有选区，则取消选区
      if (this.hasSelection) {
        this.clearSelection();
        return;
      }
      
      const layer = this.layers[this.activeLayerIndex];
      const layerCanvas = this.layerCanvases[layer.id];
      
      if (!layerCanvas) return;
      
      const ctx = layerCanvas.getContext('2d');
      const imageData = ctx.getImageData(0, 0, layerCanvas.width, layerCanvas.height);
      const data = imageData.data;
      
      // 创建选区数据（与图层大小相同的布尔数组）
      this.selectionData = new Uint8Array(layerCanvas.width * layerCanvas.height);
      
      // 遍历像素，将非透明像素标记为选中
      for (let i = 0; i < data.length; i += 4) {
        const alpha = data[i + 3];
        if (alpha > 0) {
          this.selectionData[i / 4] = 1;
        }
      }
      
      this.hasSelection = true;
      this.selectedLayerIndex = this.activeLayerIndex; // 记录选区所属的图层
      
      // 显示选区
      this.showSelection();
    },
    
    // 显示选区
    showSelection() {
      if (!this.hasSelection || !this.selectionData) return;
      
      const layer = this.layers[this.selectedLayerIndex];
      const layerCanvas = this.layerCanvases[layer.id];
      
      if (!layerCanvas) return;
      
      // 创建临时画布用于显示选区
      const tempCanvas = this.$refs.tempCanvas;
      const tempCtx = tempCanvas.getContext('2d');
      
      // 清除临时画布
      tempCtx.clearRect(0, 0, tempCanvas.width, tempCanvas.height);
      
      // 创建一个离屏画布用于绘制原始大小的选区
      const offscreenCanvas = document.createElement('canvas');
      offscreenCanvas.width = layerCanvas.width;
      offscreenCanvas.height = layerCanvas.height;
      const offscreenCtx = offscreenCanvas.getContext('2d');
      
      // 启用抗锯齿
      offscreenCtx.imageSmoothingEnabled = true;
      offscreenCtx.imageSmoothingQuality = 'high';
      
      // 设置选区颜色（淡蓝色，半透明）
      offscreenCtx.fillStyle = 'rgba(33, 150, 243, 0.25)';
      
      // 首先绘制图层内容作为蒙版
      offscreenCtx.drawImage(layerCanvas, 0, 0);
      
      // 使用source-in混合模式，只在原图不透明的地方显示选区
      offscreenCtx.globalCompositeOperation = 'source-in';
      offscreenCtx.fillRect(0, 0, offscreenCanvas.width, offscreenCanvas.height);
      
      // 重置混合模式
      offscreenCtx.globalCompositeOperation = 'source-over';
      
      // 获取当前图层的偏移量
      const offsetX = layer.offsetX || 0;
      const offsetY = layer.offsetY || 0;
      
      // 计算缩放和拖动后的位置
      const zoomFactor = this.zoomLevel / 100;
      const displaySize = this.displayCanvasSize;
      const scaledSize = displaySize * zoomFactor;
      
      // 计算基础偏移（包括缩放和拖动）
      const baseOffsetX = (displaySize - scaledSize) / 2 + this.dragOffsetX;
      const baseOffsetY = (displaySize - scaledSize) / 2 + this.dragOffsetY;
      
      // 计算最终偏移（包括图层自身偏移）
      const finalOffsetX = baseOffsetX + (offsetX * zoomFactor);
      const finalOffsetY = baseOffsetY + (offsetY * zoomFactor);
      
      // 启用临时画布的抗锯齿
      tempCtx.imageSmoothingEnabled = true;
      tempCtx.imageSmoothingQuality = 'high';
      
      // 绘制填充选区
      tempCtx.drawImage(
        offscreenCanvas,
        0, 0, offscreenCanvas.width, offscreenCanvas.height,
        finalOffsetX, finalOffsetY, scaledSize, scaledSize
      );
      
      // 添加选区边界线
      tempCtx.strokeStyle = '#00a8ff';
      tempCtx.lineWidth = 1;
      tempCtx.setLineDash([5, 3]);
      
      // 为边界创建另一个离屏画布
      const borderCanvas = document.createElement('canvas');
      borderCanvas.width = layerCanvas.width;
      borderCanvas.height = layerCanvas.height;
      const borderCtx = borderCanvas.getContext('2d');
      
      // 创建选区边界路径
      for (let y = 0; y < layerCanvas.height; y++) {
        for (let x = 0; x < layerCanvas.width; x++) {
          const index = y * layerCanvas.width + x;
          if (this.selectionData[index]) {
            // 检查周围像素是否都被选中，只绘制边界
            const hasUnselectedNeighbor = 
              (x === 0 || !this.selectionData[index - 1]) || // 左
              (x === layerCanvas.width - 1 || !this.selectionData[index + 1]) || // 右
              (y === 0 || !this.selectionData[index - layerCanvas.width]) || // 上
              (y === layerCanvas.height - 1 || !this.selectionData[index + layerCanvas.width]); // 下
            
            if (hasUnselectedNeighbor) {
              borderCtx.fillRect(x, y, 1, 1);
            }
          }
        }
      }
      
      // 平滑边界（使用滤镜）
      borderCtx.filter = 'blur(0.5px)';
      borderCtx.drawImage(borderCanvas, 0, 0);
      borderCtx.filter = 'none';
      
      // 绘制边界到临时画布
      tempCtx.drawImage(
        borderCanvas,
        0, 0, borderCanvas.width, borderCanvas.height,
        finalOffsetX, finalOffsetY, scaledSize, scaledSize
      );
      
      // 显示临时画布
      tempCanvas.style.display = 'block';
      tempCanvas.style.position = 'absolute';
      tempCanvas.style.pointerEvents = 'none';
      tempCanvas.style.top = '0';
      tempCanvas.style.left = '0';
      tempCanvas.style.zIndex = '1000';
    },
    
    // 清除选区
    clearSelection() {
      this.hasSelection = false;
      this.selectionData = null;
      this.selectedLayerIndex = -1;
      
      // 隐藏临时画布
      const tempCanvas = this.$refs.tempCanvas;
      tempCanvas.style.display = 'none';
      
      // 清除临时画布内容
      const tempCtx = tempCanvas.getContext('2d');
      tempCtx.clearRect(0, 0, tempCanvas.width, tempCanvas.height);
      
      // 重绘画布以更新显示
      this.redrawCanvas();
    },
    
    // 触摸事件处理
    handleTouchStart(e) {
      // 如果当前是拖动模式，交给startDrag处理
      if (this.zoomLevel > 100 && !this.currentTool.active) {
        this.startDrag(e);
        return;
      }
      
      e.preventDefault(); // 阻止默认行为，如页面滚动
      
      if (!this.imageLoaded || this.activeLayerIndex < 0 || !this.currentTool.active) return;
      
      // 保存当前状态
      this.saveCanvasState();
      
      this.isDrawing = true;
      
      const touch = e.touches[0];
      const rect = this.$refs.canvas.getBoundingClientRect();
      
      // 计算准确的触摸坐标，考虑设备像素比、画布缩放和用户设置的缩放
      const scaleX = this.$refs.canvas.width / rect.width;
      const scaleY = this.$refs.canvas.height / rect.height;
      const zoomFactor = this.zoomLevel / 100;
      
      // 调整坐标以适应缩放和拖动
      const canvasCenterX = rect.width / 2;
      const canvasCenterY = rect.height / 2;
      const relativeX = (touch.clientX - rect.left - canvasCenterX) / zoomFactor + canvasCenterX - this.dragOffsetX / zoomFactor;
      const relativeY = (touch.clientY - rect.top - canvasCenterY) / zoomFactor + canvasCenterY - this.dragOffsetY / zoomFactor;
      
      this.lastX = relativeX * scaleX;
      this.lastY = relativeY * scaleY;
    },
    
    handleTouchMove(e) {
      // 如果当前是拖动模式，交给doDrag处理
      if (this.isDragging) {
        this.doDrag(e);
        return;
      }
      
      e.preventDefault(); // 阻止默认行为，如页面滚动
      
      if (!this.isDrawing) return;
      
      const touch = e.touches[0];
      const rect = this.$refs.canvas.getBoundingClientRect();
      
      // 计算准确的触摸坐标，考虑设备像素比、画布缩放和用户设置的缩放
      const scaleX = this.$refs.canvas.width / rect.width;
      const scaleY = this.$refs.canvas.height / rect.height;
      const zoomFactor = this.zoomLevel / 100;
      
      // 调整坐标以适应缩放和拖动
      const canvasCenterX = rect.width / 2;
      const canvasCenterY = rect.height / 2;
      const relativeX = (touch.clientX - rect.left - canvasCenterX) / zoomFactor + canvasCenterX - this.dragOffsetX / zoomFactor;
      const relativeY = (touch.clientY - rect.top - canvasCenterY) / zoomFactor + canvasCenterY - this.dragOffsetY / zoomFactor;
      
      const x = relativeX * scaleX;
      const y = relativeY * scaleY;
      
      this.performDrawing(x, y);
    },
    
    // 图像拖动相关方法
    startDrag(e) {
      // 只有在按住空格键或触摸时才启用拖动
      if ((e.type === 'mousedown' && this.isSpacePressed) || e.type === 'touchstart') {
      this.isDragging = true;
        this.dragStartX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
        this.dragStartY = e.type === 'mousedown' ? e.clientY : e.touches[0].clientY;
      
        // 更改鼠标样式为抓取状态
      if (e.type === 'mousedown') {
          this.$refs.canvas.style.cursor = 'grabbing';
        }
      }
    },
    
    doDrag(e) {
      if (!this.isDragging) return;
      
      let currentX, currentY;
      
      if (e.type === 'mousemove') {
        currentX = e.clientX;
        currentY = e.clientY;
      } else if (e.type === 'touchmove') {
        const touch = e.touches[0];
        currentX = touch.clientX;
        currentY = touch.clientY;
        e.preventDefault();
      }
      
      // 计算拖动距离
      const deltaX = currentX - this.dragStartX;
      const deltaY = currentY - this.dragStartY;
      
      // 更新拖动偏移
      this.dragOffsetX += deltaX;
      this.dragOffsetY += deltaY;
      
      // 更新起始位置
      this.dragStartX = currentX;
      this.dragStartY = currentY;
      
      // 重绘画布
      this.redrawCanvas();
    },
    
    endDrag() {
      this.isDragging = false;
      // 恢复鼠标样式为抓手状态（如果空格键仍然按下）
      if (this.isSpacePressed) {
        this.$refs.canvas.style.cursor = 'grab';
      } else {
        this.$refs.canvas.style.cursor = 'default';
      }
    },
    
    // 图层移动控制
    toggleLayerMoveControls() {
      this.showLayerMoveControls = !this.showLayerMoveControls;
    },
    
    moveLayerPosition(dx, dy) {
      if (this.activeLayerIndex < 0 || this.activeLayerIndex >= this.layers.length) return;
      
      // 保存当前状态
      this.saveCanvasState();
      
      // 定义移动步长（像素）
      const moveStep = 1;
      
      // 更新图层位置
      this.layers[this.activeLayerIndex].offsetX = (this.layers[this.activeLayerIndex].offsetX || 0) + (dx * moveStep);
      this.layers[this.activeLayerIndex].offsetY = (this.layers[this.activeLayerIndex].offsetY || 0) + (dy * moveStep);
      
      // 重绘画布
      this.redrawCanvas();
    },
    
    resetLayerPosition() {
      if (this.activeLayerIndex < 0) return;
      
      // 保存当前状态
      this.saveCanvasState();
      
      // 重置图层位置
      this.layers[this.activeLayerIndex].offsetX = 0;
      this.layers[this.activeLayerIndex].offsetY = 0;
      
      // 重绘画布
      this.redrawCanvas();
    },
    
    // 填充图层选项
    openFillLayerOptions() {
      this.showFillLayerOptions = true;
    },
    
    // 处理填充图片上传
    handleFillImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      
      // 创建预览URL
      this.fillLayerOptions.previewUrl = URL.createObjectURL(file);
      
      // 加载图片
      const img = new Image();
      img.onload = () => {
        this.fillLayerOptions.image = img;
      };
      img.src = this.fillLayerOptions.previewUrl;
    },
    
    // 修改填充图层方法
    applyFillLayer() {
      if (this.activeLayerIndex < 0) return;
      
      // 保存当前状态
      this.saveCanvasState();
      
      const layer = this.layers[this.activeLayerIndex];
      const layerCanvas = this.layerCanvases[layer.id];
      
      if (!layerCanvas) return;
      
      try {
        // 创建临时画布用于保存原始图像
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = layerCanvas.width;
        tempCanvas.height = layerCanvas.height;
        const tempCtx = tempCanvas.getContext('2d');
        
        // 复制原始图层到临时画布
        tempCtx.drawImage(layerCanvas, 0, 0);
        
        // 获取原始图层的上下文
        const ctx = layerCanvas.getContext('2d');
        
        // 清除原图层内容
        ctx.clearRect(0, 0, layerCanvas.width, layerCanvas.height);
        
        if (this.fillLayerOptions.type === 'color') {
          // 纯色填充
          ctx.fillStyle = this.fillLayerOptions.color;
          ctx.fillRect(0, 0, layerCanvas.width, layerCanvas.height);
        } else if (this.fillLayerOptions.type === 'image' && this.fillLayerOptions.image) {
          // 图片填充 - 创建平铺图案
          const pattern = ctx.createPattern(this.fillLayerOptions.image, 'repeat');
          ctx.fillStyle = pattern;
          ctx.fillRect(0, 0, layerCanvas.width, layerCanvas.height);
        }
        
        // 设置混合模式为destination-in
        ctx.globalCompositeOperation = 'destination-in';
        
        // 绘制原始图像作为蒙版
        ctx.drawImage(tempCanvas, 0, 0);
        
        // 重置混合模式
        ctx.globalCompositeOperation = 'source-over';
        
        console.log('成功应用图层填充');
        
        // 清理预览URL
        if (this.fillLayerOptions.previewUrl) {
          URL.revokeObjectURL(this.fillLayerOptions.previewUrl);
          this.fillLayerOptions.previewUrl = null;
        }
      } catch (error) {
        console.error('应用图层填充时出错:', error);
      }
      
      // 同步到高分辨率画布
      this.createHighResCanvasFromDisplay(layer.id);
      
      // 更新缩略图
      this.updateLayerThumbnail(this.activeLayerIndex);
      
      // 重绘主画布
      this.redrawCanvas();
      
      // 关闭填充图层选项面板
      this.showFillLayerOptions = false;
    },
    
    handleKeyDown(e) {
      if (e.code === 'Space' && !this.isSpacePressed) {
        e.preventDefault(); // 阻止页面滚动
        this.isSpacePressed = true;
        // 更改鼠标样式为抓手
        this.$refs.canvas.style.cursor = 'grab';
      }
    },
    
    handleKeyUp(e) {
      if (e.code === 'Space') {
        this.isSpacePressed = false;
        // 恢复默认鼠标样式
        this.$refs.canvas.style.cursor = 'default';
}
    },
    
    goToClassicVersion() {
      this.$router.push('/');
    },
    
    // 打开填充选项
    openFillOptions() {
      if (!this.hasSelection) return;
      this.showFillOptions = true;
    },
    
    // 应用填充
    applyFill() {
      if (!this.hasSelection || !this.selectionData) return;
      
      // 保存当前状态
      this.saveCanvasState();
      
      const layer = this.layers[this.activeLayerIndex];
      const layerCanvas = this.layerCanvases[layer.id];
      
      if (!layerCanvas) return;
      
      const ctx = layerCanvas.getContext('2d');
      
      // 创建临时画布用于保存原始内容
      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = layerCanvas.width;
      tempCanvas.height = layerCanvas.height;
      const tempCtx = tempCanvas.getContext('2d');
      
      // 保存原始图层内容
      tempCtx.drawImage(layerCanvas, 0, 0);
      
      // 创建选区蒙版画布
      const maskCanvas = document.createElement('canvas');
      maskCanvas.width = layerCanvas.width;
      maskCanvas.height = layerCanvas.height;
      const maskCtx = maskCanvas.getContext('2d');
      
      // A. 创建选区形状
      const imageData = ctx.getImageData(0, 0, layerCanvas.width, layerCanvas.height);
      const data = imageData.data;
      
      // 将选区数据转换为ImageData
      const maskImageData = new ImageData(layerCanvas.width, layerCanvas.height);
      const maskData = maskImageData.data;
      
      for (let i = 0; i < this.selectionData.length; i++) {
        if (this.selectionData[i]) {
          const pixelIndex = i * 4;
          // 只在原图不透明的地方创建选区
          if (data[pixelIndex + 3] > 0) {
            maskData[pixelIndex] = 255;
            maskData[pixelIndex + 1] = 255;
            maskData[pixelIndex + 2] = 255;
            maskData[pixelIndex + 3] = 255;
          }
        }
      }
      
      // 将选区蒙版绘制到蒙版画布
      maskCtx.putImageData(maskImageData, 0, 0);
      
      // 平滑选区边缘
      maskCtx.filter = 'blur(0.5px)';
      maskCtx.drawImage(maskCanvas, 0, 0);
      maskCtx.filter = 'none';
      
      // 清空原画布
      ctx.clearRect(0, 0, layerCanvas.width, layerCanvas.height);
      
      // B. 创建填充画布
      const fillCanvas = document.createElement('canvas');
      fillCanvas.width = layerCanvas.width;
      fillCanvas.height = layerCanvas.height;
      const fillCtx = fillCanvas.getContext('2d');
      
      // 在填充画布上绘制选区形状
      fillCtx.drawImage(maskCanvas, 0, 0);
      
      // 使用选区作为蒙版进行填充
      fillCtx.globalCompositeOperation = 'source-in';
      fillCtx.fillStyle = this.fillOptions.color;
      fillCtx.fillRect(0, 0, fillCanvas.width, fillCanvas.height);
      
      // C. 恢复原始内容
      ctx.drawImage(tempCanvas, 0, 0);
      
      // 在原始内容上叠加填充
      ctx.globalCompositeOperation = 'destination-out';
      ctx.drawImage(maskCanvas, 0, 0);
      
      ctx.globalCompositeOperation = 'source-over';
      ctx.drawImage(fillCanvas, 0, 0);
      
      // 同步到高分辨率画布
      this.createHighResCanvasFromDisplay(layer.id);
      
      // 更新缩略图
      this.updateLayerThumbnail(this.activeLayerIndex);
      
      // 清除选区
      this.clearSelection();
      
      // 重绘主画布
      this.redrawCanvas();
      
      // 关闭填充选项面板
      this.showFillOptions = false;
    },
    
    // 全选功能
    toggleSelectAll() {
      if (this.activeLayerIndex < 0) return;
      
      if (this.hasSelection) {
        // 如果已有选区，则清除选区
        this.clearSelection();
      } else {
        // 创建新选区
        const layer = this.layers[this.activeLayerIndex];
        const layerCanvas = this.layerCanvases[layer.id];
        
        if (!layerCanvas) return;
        
        const ctx = layerCanvas.getContext('2d');
        const imageData = ctx.getImageData(0, 0, layerCanvas.width, layerCanvas.height);
        const data = imageData.data;
        
        // 创建选区数据（与图层大小相同的布尔数组）
        this.selectionData = new Uint8Array(layerCanvas.width * layerCanvas.height);
        
        // 遍历像素，将非透明像素标记为选中
        for (let i = 0; i < data.length; i += 4) {
          const alpha = data[i + 3];
          if (alpha > 0) {
            this.selectionData[i / 4] = 1;
          }
        }
        
        this.hasSelection = true;
        this.selectedLayerIndex = this.activeLayerIndex;
        
        // 显示选区
        this.showSelection();
      }
    },
  }
}
</script>

<style scoped>
.home-container {
  display: flex;
  width: 100%;
  height: 100vh;
  background: #f5f5f5;
  overflow: hidden;
}

.tools-sidebar {
  width: 320px;
  height: 100%;
  background: #1e1e1e;
  border-right: 1px solid #333;
  overflow-y: auto;
  padding: 16px;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);
  color: #fff;
}

.canvas-area {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f0f0f0;
  position: relative;
}

.top-toolbar {
  height: 48px;
  padding: 0 16px;
  background: #1e1e1e;
  border-bottom: 1px solid #333;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
}

.bottom-statusbar {
  height: 32px;
  padding: 0 16px;
  background: #1e1e1e;
  border-top: 1px solid #333;
  display: flex;
  align-items: center;
  gap: 24px;
  color: #999;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #666;
}

.status-label {
  color: #999;
}

.canvas-container {
  flex: 1;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2c2c2c; /* 深色背景 */
  user-select: none; /* 防止拖动时选中文本 */
}

.canvas-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100%;
  min-height: 100%;
}

.main-canvas {
  position: relative;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  image-rendering: pixelated; /* 像素图片时保持清晰 */
  transform-origin: center center;
}

/* 添加画布背景网格 */
.canvas-grid {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  background-image: 
    linear-gradient(45deg, #333 25%, transparent 25%),
    linear-gradient(-45deg, #333 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #333 75%),
    linear-gradient(-45deg, transparent 75%, #333 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
  opacity: 0.1;
}

.module-card {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.module-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 0 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.tool-btn {
  padding: 6px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fff;
  color: #333;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.tool-btn:hover {
  background: #f5f5f5;
}

.tool-btn:active {
  background: #e8e8e8;
}

.tool-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.tool-btn.active {
  background: #e6f7ff;
  border-color: #1890ff;
  color: #1890ff;
}

.button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.zoom-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.layers-list {
  max-height: 300px;
  overflow-y: auto;
  margin-bottom: 12px;
}

.layer-item {
  display: flex;
  align-items: center;
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 8px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
}

.layer-item:hover {
  background: #f5f5f5;
}

.layer-item.active-layer {
  border-color: #1890ff;
  background: #e6f7ff;
}

.layer-preview {
  width: 48px;
  height: 48px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  margin-right: 8px;
  flex-shrink: 0;
}

.layer-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.layer-info {
  flex: 1;
  min-width: 0;
}

.layer-name {
  font-size: 13px;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.layer-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.layer-opacity {
  font-size: 12px;
  color: #666;
  min-width: 36px;
}

.layer-actions {
  display: flex;
  gap: 4px;
}

.visibility-btn, 
.order-btn,
.delete-btn {
  padding: 4px;
  border: none;
  background: none;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.2s;
}

.visibility-btn:hover, 
.order-btn:hover,
.delete-btn:hover {
  opacity: 1;
}

.action-icon {
  width: 16px;
  height: 16px;
}

.order-icon {
  font-size: 12px;
}

.filter-controls {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.filter-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.filter-item label {
  font-size: 13px;
  color: #666;
}

.filter-item input[type="range"] {
  width: 100%;
}

.blend-select {
  width: 100%;
  padding: 6px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 13px;
}

.tool-options {
  margin-top: 12px;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 4px;
}

.tool-options label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  color: #666;
  margin-bottom: 8px;
}

.tool-options label:last-child {
  margin-bottom: 0;
}

input[type="range"] {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background: #e0e0e0;
  outline: none;
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #1890ff;
  cursor: pointer;
}

.preset-action-wrapper {
  display: flex;
  gap: 8px;
}

.preset-select {
  flex: 1;
  padding: 6px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 13px;
}

.plus-icon {
  font-size: 16px;
  line-height: 1;
}

.file-input {
  display: none;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #999;
}

.upload-btn {
  background: linear-gradient(135deg, #4CAF50, #8BC34A);
  color: white;
  font-weight: 500;
}

.upload-btn:hover {
  background: linear-gradient(135deg, #43a047, #7cb342);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.2);
}

.upload-btn:disabled {
  background: linear-gradient(135deg, #e0e0e0, #eeeeee);
  transform: none;
  box-shadow: none;
}

.upload-btn .icon {
  font-size: 16px;
  font-weight: bold;
}

/* 添加遮罩层样式 */
.stroke-tool-panel {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.layer-tool-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.layer-tool-btn {
  padding: 6px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fff;
  color: #333;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.layer-tool-btn:hover {
  background: #f5f5f5;
}

.layer-tool-btn:active {
  background: #e8e8e8;
}

.layer-tool-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.layer-tool-btn.active {
  background: #e6f7ff;
  border-color: #1890ff;
  color: #1890ff;
}

/* 描边工具面板样式 */
.option-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.option-title {
  margin: 0;
  font-size: 15px;
  color: #333;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 20px;
  line-height: 1;
  color: #999;
  cursor: pointer;
  padding: 0;
}

.close-btn:hover {
  color: #666;
  }
  
.layer-tool-options {
  margin-top: 16px;
  border-top: 1px solid #eee;
  padding-top: 16px;
}

.option-panel {
  background: #f8f8f8;
  border-radius: 8px;
  padding: 16px;
}

.stroke-option {
  margin-bottom: 16px;
  }
  
.stroke-option label {
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #555;
  font-size: 14px;
  }

.stroke-option input[type="range"] {
  width: 100%;
  -webkit-appearance: none;
  appearance: none;
  height: 6px;
  background: linear-gradient(to right, #2196F3, #90CAF9);
  border-radius: 3px;
  outline: none;
}

.stroke-option input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  background: white;
  border: 2px solid #2196F3;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(33, 150, 243, 0.4);
}

.color-picker {
  width: 100%;
  height: 30px;
  padding: 2px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.stroke-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}

.apply-btn,
.cancel-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.apply-btn {
  background: #1890ff;
  color: white;
}

.apply-btn:disabled {
  background: #bae7ff;
  cursor: not-allowed;
}

.cancel-btn {
  background: #f0f0f0;
  color: #333;
}

.apply-btn:hover:not(:disabled) {
  background: #40a9ff;
}

.cancel-btn:hover {
  background: #e0e0e0;
}

.action-btn {
  background: #f0f0f0;
  color: #333;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.action-btn:hover {
  background: #e0e0e0;
}

.action-btn:active {
  background: #d0d0d0;
}

.action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-btn.active {
  background: #e6f7ff;
  border-color: #1890ff;
  color: #1890ff;
}

.icon {
  font-size: 16px;
}

.classic-version-btn {
  background: #8BC34A;
  color: white;
}

.classic-version-btn:hover {
  background: #7cb342;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.2);
}

.classic-version-btn:active {
  background: #7cb342;
}

.classic-version-btn:disabled {
  background: #e0e0e0;
  transform: none;
  box-shadow: none;
}

.move-controls-grid {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.move-btn {
  background: #f0f0f0;
  color: #333;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.move-btn:hover {
  background: #e0e0e0;
}

.move-btn:active {
  background: #d0d0d0;
}

.move-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.move-btn.active {
  background: #e6f7ff;
  border-color: #1890ff;
  color: #1890ff;
}

.direction-icon {
  font-size: 16px;
}

.move-center {
  flex: 1;
  text-align: center;
}

.pixel-info {
  font-size: 12px;
  color: #666;
}

.reset-position-btn {
  background: #f0f0f0;
  color: #333;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.reset-position-btn:hover {
  background: #e0e0e0;
}

.reset-position-btn:active {
  background: #d0d0d0;
}

.reset-position-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.reset-position-btn.active {
  background: #e6f7ff;
  border-color: #1890ff;
  color: #1890ff;
}

.layer-move-controls {
  margin-top: 16px;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 4px;
}

.layer-move-controls.active-tool {
  border: 2px dashed #1890ff;
}

/* 图层操作模块样式 */
.operation-module {
  background-color: #333;
  border-radius: 4px;
  margin-bottom: 10px;
  padding: 10px;
  color: #fff;
}

.operation-module h3 {
  font-size: 14px;
  margin: 0 0 8px 0;
  border-bottom: 1px solid #555;
  padding-bottom: 5px;
}

.btn-group {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 8px;
}

.sidebar-btn {
  background-color: #444;
  color: #eee;
  border: none;
  padding: 5px 8px;
  border-radius: 3px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  flex: 1;
  min-width: 30px;
  text-align: center;
}

.sidebar-btn:hover {
  background-color: #555;
}

.sidebar-btn:active {
  background-color: #666;
}

.sidebar-btn.active {
  background-color: #2a7ae2;
}

/* 图层移动控制样式 */
.move-controls {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
  margin-top: 8px;
}

.move-btn {
  background-color: #444;
  color: #eee;
  border: none;
  padding: 5px;
  font-size: 12px;
  cursor: pointer;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.move-btn:hover {
  background-color: #555;
}

.move-btn.center {
  grid-column: 2;
  grid-row: 2;
}

/* 图层管理样式 */
.layer-module {
  flex: 1;
  overflow-y: auto;
  min-height: 200px;
  max-height: 300px;
  margin-bottom: 10px;
}

.layer-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.layer-item {
  display: flex;
  align-items: center;
  padding: 5px;
  border-bottom: 1px solid #444;
  cursor: pointer;
  transition: background-color 0.2s;
}

.layer-item:hover {
  background-color: #444;
}

.layer-item.active {
  background-color: #2a7ae2;
}

.layer-visibility {
  width: 20px;
  margin-right: 5px;
  cursor: pointer;
}

.layer-thumbnail {
  width: 30px;
  height: 30px;
  margin-right: 5px;
  background-color: #666;
  border: 1px solid #888;
}

.layer-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}

.canvas-grid {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: 10px 10px;
  background-image:
    linear-gradient(to right, rgba(150, 150, 150, 0.1) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(150, 150, 150, 0.1) 1px, transparent 1px);
  pointer-events: none;
}

/* 添加下拉菜单样式 */
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #444;
  min-width: 120px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
  z-index: 1;
  border-radius: 3px;
}

.dropdown-content button {
  color: #eee;
  padding: 8px 10px;
  text-decoration: none;
  display: block;
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  font-size: 12px;
  cursor: pointer;
}

.dropdown-content button:hover {
  background-color: #555;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.toolbar-status-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #333;
  padding: 5px 10px;
  color: #eee;
  border-top: 1px solid #444;
  font-size: 12px;
}

.status-info {
  display: flex;
  gap: 15px;
}

/* 编辑操作模块样式 */
.edit-actions-module {
  background: linear-gradient(to bottom, #2c3e50, #1e2b38);
  border-radius: 8px;
  border: 1px solid #34495e;
  padding: 15px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  margin-bottom: 20px;
}

.edit-actions-module .module-title {
  color: #ecf0f1;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 15px;
  border-bottom: 1px solid #34495e;
  padding-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.action-groups {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.action-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.action-group-title {
  font-size: 0.85rem;
  color: #bdc3c7;
  margin-bottom: 5px;
  font-weight: 500;
}

.primary-actions {
  display: flex;
  gap: 10px;
  justify-content: space-between;
}

.action-buttons-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.action-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #34495e;
  color: #ecf0f1;
  border: none;
  border-radius: 6px;
  padding: 8px 5px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.85rem;
  text-align: center;
  min-height: 65px;
}

.action-btn:hover {
  background: #3498db;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.action-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.action-btn:disabled {
  background: #2c3e50;
  color: #7f8c8d;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
  opacity: 0.6;
}

.primary-action {
  flex: 1;
  padding: 12px 8px;
}

.action-icon {
  font-size: 1.4rem;
  margin-bottom: 5px;
}

.action-label {
  font-size: 0.75rem;
  font-weight: 500;
}

.classic-version-btn {
  background: #16a085;
}

.classic-version-btn:hover {
  background: #1abc9c;
}

.active-tool {
  background: #3498db;
  box-shadow: 0 0 0 2px #2980b9;
}

/* 图层移动控制样式 */
.layer-move-controls {
  background: #2c3e50;
  border-radius: 8px;
  margin-top: 15px;
  padding: 15px;
  border: 1px solid #34495e;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.move-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #34495e;
}

.move-panel-title {
  font-weight: 600;
  color: #ecf0f1;
  font-size: 0.9rem;
}

.position-display {
  color: #3498db;
  font-size: 0.85rem;
  background: #1e2b38;
  padding: 3px 8px;
  border-radius: 4px;
  border: 1px solid #34495e;
}

.move-controls-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 15px;
}

.direction-btn {
  background: #34495e;
  color: #ecf0f1;
  border: none;
  border-radius: 6px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.direction-btn:hover {
  background: #3498db;
  box-shadow: 0 0 10px rgba(52, 152, 219, 0.5);
}

.direction-btn:active {
  transform: scale(0.95);
}

.direction-icon {
  font-size: 1.2rem;
}

.up-btn {
  grid-column: 2;
  grid-row: 1;
}

.left-btn {
  grid-column: 1;
  grid-row: 2;
}

.direction-center {
  grid-column: 2;
  grid-row: 2;
  background: #1e2b38;
  border-radius: 6px;
  border: 1px dashed #34495e;
}

.right-btn {
  grid-column: 3;
  grid-row: 2;
}

.down-btn {
  grid-column: 2;
  grid-row: 3;
}

.move-panel-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.reset-position-btn, .close-panel-btn {
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 5px;
}

.reset-position-btn {
  background: #16a085;
  color: white;
}

.reset-position-btn:hover {
  background: #1abc9c;
}

.close-panel-btn {
  background: #e74c3c;
  color: white;
}

.close-panel-btn:hover {
  background: #c0392b;
}

.reset-icon, .close-icon {
  font-size: 0.9rem;
}

.fill-layer-options {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.option-panel {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  max-width: 90%;
  width: 400px;
}

.option-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.option-title {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 24px;
  line-height: 1;
  color: #999;
  cursor: pointer;
  padding: 0;
}

.close-btn:hover {
  color: #666;
}

.option-content {
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 16px;
}

.form-label {
  display: block;
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.fill-type-buttons {
  display: flex;
  gap: 10px;
}

.fill-type-btn {
  flex: 1;
  background: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px 16px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s;
}

.fill-type-btn:hover {
  background: #e6f7ff;
  border-color: #1890ff;
  color: #1890ff;
}

.fill-type-btn.active {
  background: #1890ff;
  border-color: #1890ff;
  color: white;
}

.color-picker-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.color-picker {
  width: 100%;
  height: 30px;
  padding: 2px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.color-value {
  font-size: 14px;
  color: #666;
}

.image-upload-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.file-input {
  display: none;
}

.upload-btn {
  background: #f5f5f5;
  color: #666;
  font-size: 14px;
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-block;
}

.upload-btn:hover {
  background: #e6f7ff;
  border-color: #1890ff;
  color: #1890ff;
}

.upload-btn:active {
  background: #1890ff;
  color: white;
  border-color: #1890ff;
}

.preview-wrapper {
  width: 100px;
  height: 100px;
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow: hidden;
  margin-right: 10px;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.option-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}

.apply-btn, .cancel-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.apply-btn {
  background: #1890ff;
  color: white;
}

.apply-btn:hover:not(:disabled) {
  background: #40a9ff;
}

.cancel-btn {
  background: #f0f0f0;
  color: #333;
}

.cancel-btn:hover {
  background: #e0e0e0;
}
</style>
